/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


(function ($, _c, undefined) {
    'use strict';

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.

    var Sage = {

        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages

                if (navigator.userAgent.match(/Trident\/7\./)) { // if IE
                    $('body').on("mousewheel", function () {
                        // remove default behavior
                        event.preventDefault();

                        //scroll without smoothing
                        var wheelDelta = event.wheelDelta;
                        var currentScrollPosition = window.pageYOffset;
                        window.scrollTo(0, currentScrollPosition - wheelDelta);
                    });
                }

                //Remove multiple instances of breadcrumbs
                $('[id^=block-basic-breadcrumbs--]').hide();

                //underline links
                $('.body-link, .toggle-btns > li > ul > li > a, .toggle-btns > li > ul > li > ul > li > a').each(function () {
                    $(this).html(function (i, html) {
                        return "<span>" + html + "</span>";
                    });
                });

                $(document).ready(function () {
                    $('#main-nav .menu-item--active-trail').closest('.toplevel-menu').addClass('active');
                    
                    // Apply tabindex = -1 to the mobile utility nav using the mobile-only class
                    const mobileUtilityNav = document.getElementById('mobile-utility');
                    if (mobileUtilityNav) {
                        mobileUtilityNav.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(element => {
                            element.setAttribute('tabindex', '-1');
                        });
                    }
                });

                //on load
                $(window).on('load', function () {

                    //Banners that should be modules used across the site.
                    //Taken from homepage section
                    var featured_events_swiper = new Swiper('#featured-events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#featured-events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        nextButton: '.featured-next',
                        prevButton: '.featured-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        }
                    });

                    var upcoming_events_swiper = new Swiper('#upcoming-events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#upcoming-events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        nextButton: '.upcoming-next',
                        prevButton: '.upcoming-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });

                    var series_swiper = new Swiper('#series-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: false,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        nextButton: '.series-next',
                        prevButton: '.series-prev',
                        pagination: '.series-pagination',
                        paginationClickable: true,
                        watchOverflow: true,
                        breakpoints: {},
                        onSlideChangeStart: function (swiper) {
                            $('#series-slider .photo').removeClass('active');
                            $('.series-photos .photo-' + swiper.activeIndex).addClass('active');
                        },
                    });

                    // Home Reveal - Taken from homepage section
                    function revealCols() {
                        var revealWidth = $('.home-reveal-cols').width();

                        if ($(window).width() > 1023) {
                            var reveal_quarter = revealWidth * 0.25;
                            var reveal_half = revealWidth * 0.50;
                            var reveal_three_quarter = revealWidth * 0.75;
                            var sec1_expand = reveal_quarter + 50;
                            var sec1_shrink = reveal_quarter - 50;
                            var sec2_expand = reveal_half + 50;
                            var sec2_shrink = reveal_half - 50;
                            var sec3_expand = reveal_three_quarter + 50;
                            var sec3_shrink = reveal_three_quarter - 50;

                            $('.home-reveal-cols .sec-1').css('clip', 'rect(0px, ' + reveal_quarter + 'px, 500px, 0px)');
                            $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + reveal_half + 'px, 500px, ' + reveal_quarter + 'px)');
                            $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + reveal_half + 'px)');
                            $('.home-reveal-cols .sec-4').css('clip', 'rect(0px, ' + revealWidth + 'px, 500px, ' + reveal_three_quarter + 'px)');
                            $('.home-reveal-cols .line1').css('left', reveal_quarter);
                            $('.home-reveal-cols .line2').css('left', reveal_half);
                            $('.home-reveal-cols .line3').css('left', reveal_three_quarter);

                            $('.trigger-reveal a').on('mouseenter', function () {
                                var reveal_col = $(this).data('tile');
                                if (reveal_col == 'sec-1') {
                                    $('.col-sec-1').css({
                                        'flex-basis': 'calc(25% + 50px)',
                                        'max-width': 'calc(25% + 50px)'
                                    });
                                    $('.col-sec-2').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('#sec-1').css('z-index', '99');
                                    $('#sec-2').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '.5', 'z-index': '1'});
                                    $('.title1').addClass('on');
                                    $('.title2').addClass('off');
                                    $('.title3').addClass('off');
                                    $('.title4').addClass('off');
                                    $('.home-reveal-cols .sec-1').css('clip', 'rect(0px, ' + sec1_expand + 'px, 500px, 0px)');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + reveal_half + 'px, 500px, ' + sec1_expand + 'px)');
                                }
                                if (reveal_col == 'sec-2') {
                                    $('.col-sec-1').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('.col-sec-2').css({
                                        'flex-basis': 'calc(25% + 100px)',
                                        'max-width': 'calc(25% + 100px)'
                                    });
                                    $('.col-sec-3').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('#sec-2').css('z-index', '99');
                                    $('#sec-1').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '.5', 'z-index': '1'});
                                    $('.title2').addClass('on');
                                    $('.title1').addClass('off');
                                    $('.title3').addClass('off');
                                    $('.title4').addClass('off');
                                    $('.home-reveal-cols .sec-1').css('clip', 'rect(0px, ' + sec1_shrink + 'px, 500px, 0px)');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + sec2_expand + 'px, 500px, ' + sec1_shrink + 'px)');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + sec2_expand + 'px)');
                                }
                                if (reveal_col == 'sec-3') {
                                    $('.col-sec-2').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('.col-sec-3').css({
                                        'flex-basis': 'calc(25% + 100px)',
                                        'max-width': 'calc(25% + 100px)'
                                    });
                                    $('.col-sec-4').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('#sec-3').css('z-index', '99');
                                    $('#sec-1').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '.5', 'z-index': '1'});
                                    $('.title3').addClass('on');
                                    $('.title1').addClass('off');
                                    $('.title2').addClass('off');
                                    $('.title4').addClass('off');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + sec2_shrink + 'px, 500px, ' + reveal_quarter + 'px)');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + sec3_expand + 'px, 500px, ' + sec2_shrink + 'px)');
                                    $('.home-reveal-cols .sec-4').css('clip', 'rect(0px, ' + revealWidth + 'px, 500px, ' + sec3_expand + 'px)');
                                }
                                if (reveal_col == 'sec-4') {
                                    $('.col-sec-3').css({
                                        'flex-basis': 'calc(25% - 50px)',
                                        'max-width': 'calc(25% - 50px)'
                                    });
                                    $('.col-sec-4').css({
                                        'flex-basis': 'calc(25% + 50px)',
                                        'max-width': 'calc(25% + 50px)'
                                    });
                                    $('#sec-4').css('z-index', '99');
                                    $('#sec-1').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '.5', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '.5', 'z-index': '1'});
                                    $('.title4').addClass('on');
                                    $('.title1').addClass('off');
                                    $('.title2').addClass('off');
                                    $('.title3').addClass('off');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + reveal_half + 'px)');
                                    $('.home-reveal-cols .sec-4').css('clip', 'rect(0px, ' + revealWidth + 'px, 500px, ' + sec3_shrink + 'px)');
                                }
                            }).on('mouseleave', function () {
                                var reveal_col = $(this).data('tile');
                                if (reveal_col == 'sec-1') {
                                    $('.col-sec-1').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-2').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('#sec-1').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '1', 'z-index': '1'});
                                    $('.title1').removeClass('on');
                                    $('.title1').removeClass('off');
                                    $('.title2').removeClass('off');
                                    $('.title3').removeClass('off');
                                    $('.title4').removeClass('off');
                                    $('.home-reveal-cols .sec-1').css('clip', 'rect(0px, ' + reveal_quarter + 'px, 500px, 0px)');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + reveal_half + 'px, 500px, ' + reveal_quarter + 'px)');
                                }
                                if (reveal_col == 'sec-2') {
                                    $('.col-sec-1').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-2').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-3').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('#sec-1').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '1', 'z-index': '1'});
                                    $('.title2').removeClass('on');
                                    $('.title2').removeClass('off');
                                    $('.title1').removeClass('off');
                                    $('.title3').removeClass('off');
                                    $('.title4').removeClass('off');
                                    $('.home-reveal-cols .sec-1').css('clip', 'rect(0px, ' + reveal_quarter + 'px, 500px, 0px)');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + reveal_half + 'px, 500px, ' + reveal_quarter + 'px)');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + reveal_half + 'px)');
                                }
                                if (reveal_col == 'sec-3') {
                                    $('.col-sec-2').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-3').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-4').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('#sec-1').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '1', 'z-index': '1'});
                                    $('.title3').removeClass('on');
                                    $('.title3').removeClass('off');
                                    $('.title1').removeClass('off');
                                    $('.title2').removeClass('off');
                                    $('.title4').removeClass('off');
                                    $('.home-reveal-cols .sec-2').css('clip', 'rect(0px, ' + reveal_half + 'px, 500px, ' + reveal_quarter + 'px)');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + reveal_half + 'px)');
                                    $('.home-reveal-cols .sec-4').css('clip', 'rect(0px, ' + revealWidth + 'px, 500px, ' + reveal_three_quarter + 'px)');
                                }
                                if (reveal_col == 'sec-4') {
                                    $('.col-sec-3').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('.col-sec-4').css({
                                        'flex-basis': '25%',
                                        'max-width': '25%'
                                    });
                                    $('#sec-1').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-2').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-3').css({'opacity': '1', 'z-index': '1'});
                                    $('#sec-4').css({'opacity': '1', 'z-index': '1'});
                                    $('.title4').removeClass('on');
                                    $('.title4').removeClass('off');
                                    $('.title1').removeClass('off');
                                    $('.title2').removeClass('off');
                                    $('.title3').removeClass('off');
                                    $('.home-reveal-cols .sec-3').css('clip', 'rect(0px, ' + reveal_three_quarter + 'px, 500px, ' + reveal_half + 'px)');
                                    $('.home-reveal-cols .sec-4').css('clip', 'rect(0px, ' + revealWidth + 'px, 500px, ' + reveal_three_quarter + 'px)');
                                }
                            });
                        }
                    }

                    revealCols();

                    $(window).on('resize', function () {
                        revealCols();
                    });

                    // history slider
                    $('.history-slider .swiper-pagination-bullet').each(function () {
                        $(this).html(function (i, html) {
                            return "<span>" + html + "</span>";
                        });
                    });

                    // drop banner
                    if ($('.drop-banner').length > 0) {
                        $('.drop-box').addClass('on');
                        $(window).on('scroll', function () {
                            var scrolled = $(window).scrollTop();
                            $('.drop-banner .photo').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                        });
                    }

                    // full banner
                    if ($('.full-banner').length > 0) {
                        $(window).on('scroll', function () {
                            var scrolled = $(window).scrollTop();
                            $('.full-banner .photo').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                        });
                    }

                    // event banner
                    if ($('.event-banner').length > 0) {
                        $(window).on('scroll', function () {
                            var scrolled = $(window).scrollTop();
                            $('.event-banner .photo').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                        });
                    }

                    // split banner
                    if ($('.split-banner').length > 0) {
                        $('.split-banner .purple-box').addClass('on');
                        $('.split-banner .gray-box').addClass('on');
                        $('.split-banner .photo').addClass('on');
                    }

                    // visit banner
                    function footer_visit() {
                        if ($('#visit').length > 0) {
                            var offset = $('#visit').offset().top;
                            if ($(window).width() < 380) {
                                var image_height = 600;
                            }
                            else {
                                var image_height = 900;
                            }
                            $(window).on('scroll', function () {
                                var scrolled = $(window).scrollTop() - offset + image_height;
                                $('#visit .photo').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                            });
                            $(window).on('resize', function () {
                                offset = $('#visit').offset().top;
                                if ($(window).width() < 380) {
                                    var image_height = 500;
                                }
                            });
                        }
                    }

                    footer_visit();

                    // testimonial banner
                    function footer_testimonial() {
                        if ($('#testimonial').length > 0) {
                            var offset = $('#testimonial').offset().top;
                            var image_height = 900;
                            $(window).on('scroll', function () {
                                var scrolled = $(window).scrollTop() - offset + image_height;
                                $('#testimonial .bg').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                            });
                            $(window).on('resize', function () {
                                offset = $('#testimonial').offset().top;
                            });
                        }
                    }

                    footer_testimonial();

                    $('#honor-roll .toggle-link').on('click', function (event) {
                        setTimeout(function () {
                            footer_testimonial();
                            footer_visit();
                        }, 750);
                    });

                    // video banner

                    //SM - Will probably paste this into the template file.
                    if ($('.video-banner').length > 0) {

                        $.getJSON('/concert-video-audio?_format=json', function (data) {
                        }).success(function (data) {
                            var fileLocation = JSON.stringify(data[0].field_content[0].field_page_header[0].field_additional_audio[0].uri[0].value);
                            var audio = new Audio(fileLocation.replace('public://', 'sites/default/files/').replace(/"/g, ''));

                            $('.sound-btn').on('click', function (event) {
                                event.preventDefault();
                                if ($(this).hasClass('off')) {
                                    audio.play();
                                    audio.addEventListener('ended', function () {
                                        this.currentTime = 0;
                                        this.play();
                                    }, false);
                                    $(this).removeClass('off');
                                }
                                else {
                                    audio.pause();
                                    $(this).addClass('off');
                                }
                            });
                        });


                        $(window).on('scroll', function () {
                            var scrolled = $(window).scrollTop();
                            $('.video-banner .photo').css('transform', 'translate3d(0, ' + scrolled * -0.2 + 'px, 0)');
                        });
                    }

                    //Sliders should not be page specific -- moving some up here:
                    var video_events_swiper = new Swiper('.video-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('.video-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        nextButton: '.video-next',
                        prevButton: '.video-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                });

                if ($('.lightbox').length > 0) {
                    $('.video-btn').on('click', function (event) {
                        event.preventDefault();
                        var video = $(this).attr('href');
                        $(video).fadeIn('400');
                        $('.lightbox-overlay').fadeIn(400);
                    });
                    $('.lightbox .close').on('click', function (event) {
                        event.preventDefault();
                        $('.lightbox').fadeOut(400);
                        $('.lightbox-overlay').fadeOut(400);
                        var vid = jQuery('.lightbox iframe[src*="vimeo"]');
                        if (vid.length > 0) {
                            var src = vid.attr('src');
                            vid.attr('src', '');
                            vid.attr('src', src);
                        }
                    });
                }

                //scrollto
                (function () {
                    if (!$('body').hasClass('page-template-template-home')) {
                        $('.scrollto').on('click', function (event) {
                            event.preventDefault();
                            //var section = $(this).attr('href');
                            $('html, body').animate({
                                scrollTop: $('#main-content').offset().top
                            }, 1000);
                        });
                    }
                })();

                //hamburger
                (function () {
                    var alert_height = $('#header').offset().top;
                    if ($(window).width() < 1023 && $(window).width() > 768) {
                        alert_height = alert_height + 81;
                    }
                    if ($(window).width() <= 768) {
                        alert_height = alert_height + 71;
                    }
                    $(window).on('resize', function () {
                        if ($(window).width() < 1023 && $(window).width() > 767) {
                            alert_height = 0;
                            alert_height = $('#header').offset().top + 81;
                        }
                        if ($(window).width() <= 768) {
                            alert_height = 0;
                            alert_height = $('#header').offset().top + 71;
                        }
                    });

                    const mainContent = document.getElementById('main-content');
                    const footer = document.getElementById('footer');
                    const focusableSelectors = 'a, button, input';

                    function setTabIndex(value) {
                        const skipNav = document.getElementById('skip');
                        const mobileNav = document.getElementById('mobile-nav');
                        const mobileUtilityNav = document.querySelector('#mobile-utility');
                        
                        const focusableElements = [
                            ...mainContent.querySelectorAll(focusableSelectors), 
                            ...footer.querySelectorAll(focusableSelectors),
                            ...(skipNav ? skipNav.querySelectorAll(focusableSelectors) : []),
                            ...document.querySelectorAll('.swiper-pagination-bullet')
                        ];
                        
                        // Add mobile nav focusable elements when menu is closed
                        if (value === -1 && mobileNav) {
                            focusableElements.push(...mobileNav.querySelectorAll(focusableSelectors));
                        }
                        
                        // Add mobile utility nav focusable elements when menu is closed
                        if (value === -1 && mobileUtilityNav) {
                            focusableElements.push(...mobileUtilityNav.querySelectorAll(focusableSelectors));
                        }
                        
                        focusableElements.forEach(element => {
                            if (value === null) {
                                element.removeAttribute('tabindex');
                            } else {
                                element.setAttribute('tabindex', value);
                            }
                        });
                    }

                    $('.hamburger').on('click', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        const hamburger = this;
                        const mobileNav = document.getElementById('mobile-nav');

                        if ($(this).hasClass('is-active')) {
                            $('#mobile-nav').css('transform', 'translate3d(0, ' + alert_height + 'px, 0)');
                            $('#mobile-nav').attr('tabindex', 'null');
                            $(hamburger).attr('aria-expanded', 'true');
                            $(mobileNav).attr('aria-hidden', 'false');
                            setTabIndex(-1); // Disable focus on main-content and footer
                            
                            // Remove tabindex from all focusable elements inside mobile menu
                            if (mobileNav) {
                                mobileNav.querySelectorAll(focusableSelectors).forEach(element => {
                                    element.removeAttribute('tabindex');
                                });
                            }
                            
                            // Remove tabindex from all focusable elements inside mobile utility nav
                            const mobileUtilityNav = document.querySelector('#mobile-utility');
                            if (mobileUtilityNav) {
                                mobileUtilityNav.querySelectorAll(focusableSelectors).forEach(element => {
                                    element.removeAttribute('tabindex');
                                });
                            }
                            
                            // Close search form if it's open
                            if ($('.search-btn').hasClass('open')) {
                                $('.search-btn').removeClass('open');
                                $('.search-btn').attr('aria-expanded', 'false');
                                $('#search').removeClass('open');
                                $('#search').attr('aria-hidden', 'true');
                                $('#q-desktop').attr('tabindex', '-1');
                            }
                        } else {
                            $('#mobile-nav').css('transform', 'translate3d(0, -100%, 0)');
                            $('#mobile-nav').attr('tabindex', '-1');
                            $(hamburger).attr('aria-expanded', 'false');
                            $(mobileNav).attr('aria-hidden', 'true');
                            
                            // Set tabindex=0 for pagination bullets and remove tabindex for other elements
                            document.querySelectorAll('.swiper-pagination-bullet').forEach(element => {
                                element.setAttribute('tabindex', '0');
                            });
                            
                            // Handle other elements
                            const skipNav = document.getElementById('skip');
                            const focusableElements = [
                                ...mainContent.querySelectorAll(focusableSelectors), 
                                ...footer.querySelectorAll(focusableSelectors),
                                ...(skipNav ? skipNav.querySelectorAll(focusableSelectors) : [])
                            ];
                            focusableElements.forEach(element => {
                                element.removeAttribute('tabindex');
                            });
                            
                            // Set tabindex=-1 for all focusable elements inside mobile menu
                            if (mobileNav) {
                                mobileNav.querySelectorAll(focusableSelectors).forEach(element => {
                                    element.setAttribute('tabindex', '-1');
                                });
                            }
                            
                            // Set tabindex=-1 for all focusable elements inside mobile utility nav
                            const mobileUtilityNav = document.querySelector('#mobile-utility');
                            if (mobileUtilityNav) {
                                mobileUtilityNav.querySelectorAll(focusableSelectors).forEach(element => {
                                    element.setAttribute('tabindex', '-1');
                                });
                            }
                            
                            // Close search form if it's open
                            if ($('.search-btn').hasClass('open')) {
                                $('.search-btn').removeClass('open');
                                $('.search-btn').attr('aria-expanded', 'false');
                                $('#search').removeClass('open');
                                $('#search').attr('aria-hidden', 'true');
                                $('#q-desktop').attr('tabindex', '-1');
                            }
                        }
                    });

                    $('#alert .close').on('click', function (event) {
                        event.preventDefault();
                        $(this).parent().hide();
                        if ($(window).width() < 1023 && $(window).width() > 767) {
                            alert_height = 81;
                        }
                        if ($(window).width() < 768) {
                            alert_height = 71;
                        }
                    });
                })();

                //mouse overs
                if ($('.studies-box').length > 0) {
                    $('.studies-box').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.photo-excerpts').length > 0) {
                    $('.photo-excerpts .cnt').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.photo-excerpts').length > 0) {
                    $('.photo-excerpts .col-xs-4').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.photo-excerpts-sm').length > 0) {
                    $('.photo-excerpts-sm .col-xs-6').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.faculty').length > 0) {
                    $('.faculty .col-xs-3').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.faculty').length > 0) {
                    $('.faculty .col-xs-4').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.event-box').length > 0) {
                    $('.event-box .row').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.event').length > 0) {
                    $('.event .row').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.jobs').length > 0) {
                    $('.jobs .col-xs-4').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.event-slide').length > 0) {
                    $('.event-slide').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.event-cta').length > 0) {
                    $('.event-cta .col-xs-6').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.news-post').length > 0) {
                    $('.news-post').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.students').length > 0) {
                    $('.students .col-xs-3').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.past-events').length > 0) {
                    $('.past-events .col-xs-4').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }
                if ($('.media-video').length > 0) {
                    $('.media-video').on('mouseenter', function () {
                        $(this).addClass('is_hover');
                    }).on('mouseleave', function () {
                        $(this).removeClass('is_hover');
                    });
                }

                //Updating dropdown selects w/ something I found on SO - SM
                // https://stackoverflow.com/questions/46363509/user-select-option-not-updating-with-jquery
                // TODO - Make this only work for jump menu dropdowns. dropdowns
                function changelogic(val) {
                    // console.log( $('#select-dropdown-auto
                    // option').find('option[text="'+val+'"]'));
                    // $('#select-dropdown-auto').find('option[text="'+val+'"]').val();

                    if ($("#select-dropdown-auto option")) {
                        var text = val;
                        var value = $("#select-dropdown-auto option").filter(function () {
                            return $(this).text() === text;
                        });

                        value.attr('selected', 'selected');

                        window.location = value.data('url');
                    }
                }

				function changelogic2(val) {
					if(val == 'All'){
						$('.audition-list .body').show();
					} else {
						if ($("#edit-tid option")) {
							var value = $("#edit-tid option[value="+val+"]").text();
							$('.audition-list .body').hide();

							$('.audition-list .body:contains('+value+')').show();
						}
					}


					return false;
                }

				function changelogic3(val) {
					$('#fanfare .views-view-grid .row:not(:first-child) .col-xs-4').each(function(){
						var item = $(this).detach();
						$('#fanfare .views-view-grid .row:first-child').append(item);
					});

					if(val == 'All'){
						$('.views-view-grid .col-xs-4').show();
					} else {
						if ($("#edit-field-issue-publication-date-value option")) {
							var value = $("#edit-field-issue-publication-date-value option[value="+val+"]").text();
							$('.views-view-grid .col-xs-4').hide();

							$('.views-view-grid .col-xs-4:contains('+value+')').show();
						}
					}


					return false;
                }

                (function () {
					if ($(".field--name-field-embed-view select.form-select").length > 0) {
                        [].slice.call(document.querySelectorAll('select.form-select')).forEach(function (el) {
                            new SelectFx(el, {onChange: changelogic2});
                        });
                    }
					if ($("#filterby select.form-select").length > 0) {
                        [].slice.call(document.querySelectorAll('select.form-select')).forEach(function (el) {
                            new SelectFx(el, {onChange: changelogic3});
                        });
                    }
                    if ($("#select-dropdown-auto").length > 0) {
                        [].slice.call(document.querySelectorAll('form#select-dropdown-auto select.cs-select')).forEach(function (el) {
                            //TODO - Check if parent is jump menu and make a conditional - SM
                            new SelectFx(el, {onChange: changelogic});
                        });
                    }
                    else {
                        [].slice.call(document.querySelectorAll('form:not(#select-dropdown-auto) select.cs-select')).forEach(function (el) {
                            new SelectFx(el);
                        });
                    }
                })();

                //toggle btns
                (function () {
                    $('.toggle-cnt .section-parent').on('click', function (event) {
                        event.preventDefault();
                        if ($(this).parent().hasClass('open')) {
                            $(this).parent().removeClass('open');
                            $(this).next().slideUp(400);
                        }
                        else {
                            $(this).parent().addClass('open');
                            $(this).next().slideDown(400);
                        }
                    });
                    $('.toggle-btns .toggle .ico').on('click', function (event) {
                        event.preventDefault();
                        if ($(this).parent().hasClass('active')) {
                            $(this).parent().removeClass('active');
                            $(this).parent().next().slideUp(400);
                        }
                        else {
                            $(this).parent().addClass('active');
                            $(this).parent().next().slideDown(400);
                        }
                    });
                    $('.toggle-box .toggle-link').on('click', function (event) {
                        if ($(this).parent().hasClass('active')) {
                            $(this).parent().removeClass('active');
                            $(this).prev().slideUp(400);
                            $(this).children('.toggle-text').text('Show More');
                        }
                        else {
                            $(this).parent().addClass('active');
                            $(this).prev().slideDown(400);
                            $(this).children('.toggle-text').text('Show Less');
                        }
                    });
                    $('.gray-box .toggle-link').on('click', function (event) {
                        if ($(this).hasClass('active')) {
                            $(this).removeClass('active');
                            $(this).prev().slideUp(400);
                            $(this).children('.toggle-text').text('Show More');
                        }
                        else {
                            $(this).addClass('active');
                            $(this).prev().slideDown(400);
                            $(this).children('.toggle-text').text('Show Less');
                        }
                    });
                })();

                //search
                (function () {
                    $('.search-btn').on('click', function (event) {
                        // Check if mobile menu is open and close it
                        if ($('.hamburger').hasClass('is-active')) {
                            $('.hamburger').removeClass('is-active');
                            $('.hamburger').attr('aria-expanded', 'false');
                            $('#mobile-nav').css('transform', 'translate3d(0, -100%, 0)');
                            $('#mobile-nav').attr('aria-hidden', 'true');
                        }
                        
                        if ($(this).hasClass('open')) {
                            $(this).removeClass('open');
                            $(this).attr('aria-expanded', 'false');
                            $('#search').removeClass('open');
                            $('#search').attr('aria-hidden', 'true');
                            $('#q-desktop').attr('tabindex', '-1');
                        }
                        else {
                            $(this).addClass('open');
                            $(this).attr('aria-expanded', 'true');
                            $('#search').addClass('open');
                            $('#search').attr('aria-hidden', 'false');
                            $('#q-desktop').attr('tabindex', '0');
                            $('#q-desktop').focus();
                        }
                    });
                })();

                //mobile menu / footer
                (function () {
                    $('#mobile-nav li .ico').on('click', function (event) {
                        event.preventDefault();
                        const icon = this;
                        const submenuId = icon.getAttribute('aria-controls');
                        const submenu = document.getElementById(submenuId);
                        
                        if (icon.classList.contains('open')) {
                            icon.classList.remove('open');
                            icon.setAttribute('aria-expanded', 'false');
                            $(submenu).slideUp(400);
                            submenu.setAttribute('aria-hidden', 'true');
                        } else {
                            icon.classList.add('open');
                            icon.setAttribute('aria-expanded', 'true');
                            $(submenu).slideDown(400);
                            submenu.setAttribute('aria-hidden', 'false');
                        }
                    });

                    //mobile footer
                    $('footer .mobile-parent .ico').on('click', function (event) {
                        event.preventDefault();
                        if ($(this).hasClass('open')) {
                            $(this).removeClass('open');
                            $(this).parent().next().slideUp(400);
                        }
                        else {
                            $(this).addClass('open');
                            $(this).parent().next().slideDown(400);
                        }
                    });
                })();

                //NEW mobile nav submenus

                let mobileNav = document.querySelector('#mobile-nav');

                if (mobileNav) {
                    mobileNav.querySelectorAll('.menu-item .sub-ico').forEach(icon => {
                        icon.addEventListener('click', (event) => {
                            event.preventDefault();
                            
                            const submenu = icon.nextElementSibling;
    
                            if (icon.classList.contains('open')) {
                                icon.classList.remove('open');
                                icon.setAttribute('aria-expanded', 'false');
                                submenu.setAttribute('aria-hidden', 'true');
                                submenu.style.height = submenu.scrollHeight + 'px';
                                setTimeout(() => {
                                    submenu.style.height = '0';
                                }, 0);
                                setTimeout(() => {
                                    submenu.style.display = 'none';
                                }, 400);
                            } else {
                                icon.classList.add('open');
                                icon.setAttribute('aria-expanded', 'true');
                                submenu.setAttribute('aria-hidden', 'false');
                                submenu.style.display = 'block';
                                submenu.style.height = '0';
                                setTimeout(() => {
                                    submenu.style.height = submenu.scrollHeight + 'px';
                                }, 0);
                            }
                        });
                    });
                }

                //mega menus
                (function () {
                    $("nav.main-nav > ul > li").hoverIntent({
                        interval: 150,
                        over: drops_show,
                        timeout: 500,
                        out: drops_hide
                    });

                    //Check if child is in keyboard focus and then add class to the nav
                    $("nav.main-nav > ul > li *").on('focus', function () {
                        $(this).closest('li.toplevel-menu').addClass('open');
                    }).on('blur', function () {
                        $(this).closest('li.toplevel-menu').removeClass('open');
                    });

                    function drops_show() {
                        $(this).addClass('open');
                    }

                    function drops_hide() {
                        $(this).removeClass('open');
                    }

                    if ($('#photo-ctas').length > 0) {
                        $('.photo-cta').each(function (e) {
                            var box = $(this);
                            var waypointLine = new Waypoint({
                                element: box[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        box.addClass('on');
                                    }
                                    if (direction === 'up') {
                                        box.removeClass('on');
                                    }
                                },
                                offset: '23%'
                            });
                        });
                    }
                })();

                //waypoints
                (function () {

                    //sidebar
                    if ($('aside').length > 0) {
                        $('aside > *').each(function (e) {
                            var aside = $(this);
                            var waypoint_aside = new Waypoint({
                                element: aside[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        aside.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }

                    //article
                    if ($('article').length > 0) {
                        $('article > *').not('form').each(function (e) {
                            var article = $(this);
                            var waypoint_article = new Waypoint({
                                element: article[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        article.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }
                    if ($('article .paragraph--type--text-content').length > 0) {
                        $('article .paragraph--type--text-content > *').not('form').each(function (e) {
                            var article = $(this);
                            var waypoint_article = new Waypoint({
                                element: article[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        article.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }

                    //studies box
                    if ($('.studies-box').length > 0) {
                        $('.studies-box').each(function (e) {
                            var studies_box = $(this);
                            var waypoint_studies_box = new Waypoint({
                                element: studies_box[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        studies_box.addClass('on');
                                    }
                                },
                                offset: '77%'
                            });
                        });
                    }

                    //cta box
                    if ($('.cta-box').length > 0) {
                        $('.cta-box').each(function (e) {
                            var cta_box = $(this);
                            var waypoint_cta_box = new Waypoint({
                                element: cta_box[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        cta_box.addClass('on');
                                    }
                                },
                                offset: '77%'
                            });
                        });
                    }

                    //photo cta box
                    if ($('.photo-cta').length > 0) {
                        $('.photo-cta').each(function (e) {
                            var photo_cta = $(this);
                            var waypoint_photo_cta = new Waypoint({
                                element: photo_cta[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        photo_cta.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }

                    //button line
                    if ($('.btn-cnt').length > 0) {
                        $('.btn-cnt').each(function (e) {
                            var button_cta = $(this);
                            var waypoint_button_cta = new Waypoint({
                                element: button_cta[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        button_cta.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }

                    //events slider
                    if ($('.events-slider, .photo-content-slider').length > 0) {
                        $('.events-slider, .photo-content-slider').each(function (e) {
                            var events = $(this);
                            var waypoint_events = new Waypoint({
                                element: events[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        events.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });

                    }

                    //Photo slider - multiple instances
                    if ($('.photo-content-slider').length > 0) {
                        $('.photo-content-slider').each(function (e) {

                            //Start separate instance of each slider
                            new Swiper('#'+ this.id + ' .swiper-container', {
                                autoplay: false,
                                slidesPerView: 1,
                                loop: $('#' + this.id + ' .swiper-container .swiper-slide').length > 1 ? true : false,
                                speed: 1200,
                                spaceBetween: 0,
                                simulateTouch: true,
                                queueStartCallbacks: true,
                                queueEndCallbacks: true,
                                loopAdditionalSlides: 0,
                                watchOverflow: true,
                                a11y: {
                                    prevSlideMessage: 'Previous slide',
                                    nextSlideMessage: 'Next slide'
                                },
                                nextButton: '.next',
                                prevButton: '.prev',
                                pagination: '.pagination',
                                paginationClickable: true,
                                breakpoints: {},
                            });
                        });

                    }

                    //box office
                    if ($('.box-office').length > 0) {
                        $('.box-office').each(function (e) {
                            var box_office = $(this);
                            var waypoint_box_office = new Waypoint({
                                element: box_office[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        box_office.addClass('on');
                                    }
                                },
                                offset: '77%'
                            });
                        });
                    }

                    //form items
                    if ($('form').length > 0) {
                        $('form li').each(function (e) {
                            var form_item = $(this);
                            var waypoint_form_item = new Waypoint({
                                element: form_item[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        form_item.addClass('on');
                                    }
                                },
                                offset: '100%'
                            });
                        });
                    }

                    //about boxes
                    if ($('.reveal').length > 0) {
                        $('.reveal').each(function (e) {
                            var box_about = $(this);
                            var waypoint_box_about = new Waypoint({
                                element: box_about[0],
                                handler: function (direction) {
                                    if (direction === 'down') {
                                        box_about.addClass('on');
                                    }
                                },
                                offset: '77%'
                            });
                        });
                    }

                })();

                //tabs
                (function () {
                    if ($('.tabs-wrapper').length > 0) {
                        $('.tab-cnt').hide();
                        $('.tab-cnt:first-child').show();
                        $('.tab-btn:first-child').addClass('active');
                        $('.tab-btn').on('click', function (event) {
                            event.preventDefault();
                            if (!$(this).hasClass('active')) {
                                $('.tab-btn').removeClass('active');
                                $(this).addClass('active');
                                var tab = $(this).data('tab');
                                $('.tab-cnt').hide();
                                $('#' + tab).fadeIn(400);
                            }
                        });
                    }
                })();

                //student popup
                (function () {
                    if ($('.student-popup').length > 0) {
                        $('#students .tertiary-btn').on('click', function (event) {
                            event.preventDefault();
                            if (!$(this).hasClass('active')) {
                                $(this).addClass('active');
                                var student = $(this).data('student');
                                $('.student-popup').hide();
                                $('#students .col-xs-3').removeClass('active');
                                $(this).parent().addClass('active');
                                $('#' + student).slideDown(400);
                                $('.students .tertiary-btn').removeClass('active');
                                $(this).addClass('active');
                                $('.students .tertiary-btn').text('Learn More');
                                $(this).text('Close');
                                $('html, body').animate({
                                    scrollTop: $('#' + student).offset().top
                                }, 1000);
                            }
                            else {
                                $(this).removeClass('active');
                                $('.students .col-xs-3').removeClass('active');
                                $('.student-popup').slideUp(400);
                                $(this).text('Learn More');
                            }
                        });
                        $('#students .close').on('click', function (event) {
                            event.preventDefault();
                            var studentData = $(this).data('student');
                            var studentSel = '[data-student=' + studentData + ']';
                            $('.tertiary-btn' + studentSel).removeClass('active').html('Learn More');
                            $('.students .col-xs-3').removeClass('active');
                            $('.student-popup').slideUp(400);
                        });
                    }
                })();

                //faculty and People Display Cards popup
                //This should seriously be completely reworked and combined with the
                // Student Profiles- SM
                (function () {

                    var popupPeopleSelector = '#about-faculty .tertiary-btn, #about-faculty .bio-popup .tertiary-btn,' +
                        ' #people-cards.with-popup .tertiary-btn, #people-cards.with-popup .bio-popup .tertiary-btn';

                    if ($('.faculty-popup').length > 0) {
                        if ($(window).width() > 768) {
                            $(popupPeopleSelector).on('click', function (event) {
                                event.preventDefault();
                                if (!$(this).hasClass('active')) {
                                    $('.faculty-popup').hide();
                                    $('#about-faculty .col-xs-4').removeClass('active');
                                    $('#about-faculty .tertiary-btn, #people-cards.with-popup .tertiary-btn').text('See Full Bio');
                                    $('#about-faculty .tertiary-btn, #people-cards.with-popup .tertiary-btn').removeClass('active');
                                    $(this).addClass('active');
                                    var faculty = $(this).data('faculty');
                                    $(this).parent().addClass('active');
                                    $('#' + faculty).slideDown(400);
                                    $(this).addClass('active');
                                    $(this).text('Close');
                                }
                                else {
                                    $(this).removeClass('active');
                                    $('.faculty .col-xs-4').removeClass('active');
                                    $('.faculty-popup').slideUp(400);
                                    $(this).text('See Full Bio');
                                }
                            });

                            //On close button click
                            $('#about-faculty a.close, #people-cards.with-popup a.close').bind('click', function (event) {
                                event.preventDefault();
                                $('#about-faculty .photo-excerpts .tertiary-btn.active, #people-cards.with-popup .photo-excerpts .tertiary-btn.active').trigger('click');
                            });
                        }
                        else {
                            $(popupPeopleSelector).on('click', function (event) {
                                event.preventDefault();
                                if (!$(this).hasClass('active')) {
                                    $(this).addClass('active');
                                    var faculty = $(this).data('mobile');
                                    $('.faculty-popup').hide();
                                    $('#about-faculty .col-xs-4, #people-cards.with-popup .col-xs-4').removeClass('active');
                                    $(this).parent().addClass('active');
                                    $('#' + faculty).slideDown(400);
                                    $('.faculty .tertiary-btn, #people-cards.with-popup .tertiary-btn').removeClass('active');
                                    $(this).addClass('active');
                                    $('.faculty .tertiary-btn, #people-cards.with-popup .tertiary-btn').text('See Full Bio');
                                    $(this).text('Close');
                                }
                                else {
                                    $(this).removeClass('active');
                                    $('.faculty .col-xs-4').removeClass('active');
                                    $('.faculty-popup').slideUp(400);
                                    $(this).text('See Full Bio');
                                }
                            });

                            //On close button click
                            $('#about-faculty a.close, #people-cards.with-popup a.close').bind('click', function (event) {
                                event.preventDefault();
                                $('#about-faculty .photo-excerpts .tertiary-btn.active, #people-cards.with-popup .photo-excerpts .tertiary-btn.active').trigger('click');
                            });
                        }
                    }
                })();

                //These dropdowns are not accessible. They should be made that way. -SM
                function submitform() {
                    var currentForm = document.getElementById("select-dropdown-auto");
                    currentForm.submit();
                    window.location.href = "/terms/";
                }

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
                //Highlight correct links in main menu
                $(document).ready(function () {
                    $('#main-nav .menu-item--active-trail').closest('.toplevel-menu').addClass('active');

                    //Accordion stuff
                    $('.tabbed-table .tab-link').on('click', function (event) {
                        event.preventDefault();
                        var tab = $(this).attr('href');
                        if (!$(this).hasClass('active')) {
                            $(tab).slideDown(300);
                            $(this).addClass('active');
                        }
                        else {
                            $(tab).slideUp(300);
                            $(this).removeClass('active');
                        }
                    });


                    /*
  *
  * Video parser
  *
   */
                    function parseVideo(url) {
                        // - Supported YouTube URL formats:
                        //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
                        //   - http://youtu.be/My2FRPA3Gf8
                        //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
                        // - Supported Vimeo URL formats:
                        //   - http://vimeo.com/25451551
                        //   - http://player.vimeo.com/video/25451551
                        // - Also supports relative URLs:
                        //   - //player.vimeo.com/video/25451551

                        url.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

                        if (RegExp.$3.indexOf('youtu') > -1) {
                            var type = 'youtube';
                        }
                        else if (RegExp.$3.indexOf('vimeo') > -1) {
                            var type = 'vimeo';
                        }

                        return {
                            type: type,
                            id: RegExp.$6
                        };
                    }
                });

            }
        },


        // Home page
        'page_node_type_flexible_content_page': {
            init: function () {

                function submitform() {
                    var currentForm = document.getElementById("select-dropdown-auto");
                    currentForm.submit();
                    window.location.href = "/terms/";
                }

                // Home Banner
                function homeSlider() {
                    var home_swiper = new Swiper('.home-banner .swiper-container', {
                        autoplay: 6000,
                        slidesPerView: 1,
                        initialSlide: 0,
                        loop: true,
                        speed: 1000,
                        spaceBetween: 0,
                        effect: 'fade',
                        fade: {
                            crossFade: false
                        },
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        runCallbacksOnInit: true,
                        loopAdditionalSlides: 2,
                        nextButton: '.next',
                        prevButton: '.prev',
                        pagination: '.pagination',
                        paginationClickable: true,
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        onInit: function (swiper) {

                        },
                        onSlideChangeStart: function (swiper) {
                            $('.swiper-slide-active .cnt').addClass('active');
                            var contentBox = $('.swiper-slide-active .sec-1').data('index');
                            $('.content-box').removeClass('on');
                            $('#content-' + contentBox).addClass('on');
                            var currentBg = $('.swiper-slide-prev .sec-1 .bg').css('background');
                            document.getElementById("bgPhoto").setAttribute('style', 'background:' + currentBg);
                        },
                        onSlideChangeEnd: function (swiper) {
                            setTimeout(function () {
                                $('.swiper-slide-prev .cnt').removeClass('active');
                                $('.swiper-slide-next .cnt').removeClass('active');
                            }, 1000);
                        },
                    });
					
					
					const oldPlayButton = document.querySelector('.home-banner .pause');
					
					if(oldPlayButton){
						oldPlayButton.outerHTML = oldPlayButton.outerHTML;
					}
					
					const playButton = document.querySelector('.home-banner .pause');

					if(playButton){
						playButton.addEventListener("click", (event) => {
							const sliderEl = document.querySelector('.home-banner #slider');
							
							if(playButton.classList.contains('play')){
								playButton.classList.remove('play');
								sliderEl.classList.remove('paused');
								home_swiper.startAutoplay();
							} else {
								playButton.classList.add('play');
								sliderEl.classList.add('paused');
								home_swiper.stopAutoplay();
							}
							
							event.stopPropagation();
							event.preventDefault();
						},true);
					}
                }

                var slides = $('.home-banner .swiper-slide').length;
                if (slides > 1) {
                    homeSlider();
                }
                else {
                    $('.home-banner .pagination').hide();
                    $('.home-banner #slider-content .prev').hide();
                    $('.home-banner #slider-content .next').hide();
                }

                function resetBanner() {
                    if ($(window).width() > 768) {
                        var slideWidth = $('.swiper-slide').width();
                        var quarter = slideWidth * 0.25;
                        var half = slideWidth * 0.50;
                        var three_quarter = slideWidth * 0.75;
                        $('.swiper-slide .sec-1').css('clip', 'rect(0px, ' + quarter + 'px, 650px, 0px)');
                        $('.swiper-slide .sec-2').css('clip', 'rect(0px, ' + half + 'px, 650px, ' + quarter + 'px)');
                        $('.swiper-slide .sec-3').css('clip', 'rect(0px, ' + three_quarter + 'px, 650px, ' + half + 'px)');
                        $('.swiper-slide .sec-4').css('clip', 'rect(0px, ' + slideWidth + 'px, 650px, ' + three_quarter + 'px)');
                        $('.slider-lines .line1').css('left', quarter);
                        $('.slider-lines .line2').css('left', half);
                        $('.slider-lines .line3').css('left', three_quarter);
                    }
                    else if ($(window).width() <= 768 && $(window).width() > 480) {
                        var slideWidth = $('.swiper-slide').width();
                        var quarter = slideWidth * 0.25;
                        var half = slideWidth * 0.50;
                        var three_quarter = slideWidth * 0.75;
                        $('.swiper-slide .sec-1').css('clip', 'rect(0px, ' + quarter + 'px, 350px, 0px)');
                        $('.swiper-slide .sec-2').css('clip', 'rect(0px, ' + half + 'px, 350px, ' + quarter + 'px)');
                        $('.swiper-slide .sec-3').css('clip', 'rect(0px, ' + three_quarter + 'px, 350px, ' + half + 'px)');
                        $('.swiper-slide .sec-4').css('clip', 'rect(0px, ' + slideWidth + 'px, 350px, ' + three_quarter + 'px)');
                        $('.slider-lines .line1').css('left', quarter);
                        $('.slider-lines .line2').css('left', half);
                        $('.slider-lines .line3').css('left', three_quarter);
                    }
                    else {
                        var slideWidth = $('.swiper-slide').width();
                        var quarter = slideWidth * 0.25;
                        var half = slideWidth * 0.50;
                        var three_quarter = slideWidth * 0.75;
                        $('.swiper-slide .sec-1').css('clip', 'rect(0px, ' + quarter + 'px, 200px, 0px)');
                        $('.swiper-slide .sec-2').css('clip', 'rect(0px, ' + half + 'px, 200px, ' + quarter + 'px)');
                        $('.swiper-slide .sec-3').css('clip', 'rect(0px, ' + three_quarter + 'px, 200px, ' + half + 'px)');
                        $('.swiper-slide .sec-4').css('clip', 'rect(0px, ' + slideWidth + 'px, 200px, ' + three_quarter + 'px)');
                        $('.slider-lines .line1').css('left', quarter);
                        $('.slider-lines .line2').css('left', half);
                        $('.slider-lines .line3').css('left', three_quarter);
                    }
                }

                if (slides > 1) {
                    resetBanner();
                }

                $(window).on('resize', function () {
                    if (slides > 1) {
                        homeSlider();
                        resetBanner();
                    }
                });

                // Home Events
                var events_swiper = new Swiper('#home-events-slider .swiper-container', {
                    autoplay: false,
                    slidesPerView: 1,
                    loop: true,
                    speed: 1200,
                    spaceBetween: 0,
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    loopAdditionalSlides: 0,
                    nextButton: '.events-next',
                    prevButton: '.events-prev',
                    breakpoints: {},
                    watchOverflow: true,
                    a11y: {
                        prevSlideMessage: 'Previous slide',
                        nextSlideMessage: 'Next slide'
                    }
                });

                // Home Series
                var series_swiper = new Swiper('#series-slider .swiper-container', {
                    autoplay: false,
                    slidesPerView: 1,
                    loop: false,
                    speed: 1200,
                    spaceBetween: 0,
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    nextButton: '.series-next',
                    prevButton: '.series-prev',
                    pagination: '.series-pagination',
                    paginationClickable: true,
                    breakpoints: {},
                    watchOverflow: true,
                    a11y: {
                        prevSlideMessage: 'Previous slide',
                        nextSlideMessage: 'Next slide'
                    },
                    onSlideChangeStart: function (swiper) {
                        $('#series-slider .photo').removeClass('active');
                        $('.series-photos .photo-' + swiper.activeIndex).addClass('active');
                    },
                });

                // Home News
                var related_swiper = new Swiper('#home-news-slider .swiper-container', {
                    autoplay: false,
                    slidesPerView: 3.5,
                    loop: true,
                    speed: 1200,
                    centeredSlides: true,
                    initialSlide: 1,
                    loopAdditionalSlides: 1,
                    spaceBetween: 40,
                    simulateTouch: true,
                    queueStartCallbacks: true,
                    queueEndCallbacks: true,
                    watchOverflow: true,
                    a11y: {
                        prevSlideMessage: 'Previous slide',
                        nextSlideMessage: 'Next slide'
                    },
                    //loopAdditionalSlides: 2,
                    nextButton: '.pdf-next',
                    prevButton: '.pdf-prev',
                    breakpoints: {
                        1280: {
                            slidesPerView: 2.5,
                        },
                        767: {
                            slidesPerView: 2,
                        },
                        580: {
                            slidesPerView: 1,
                        },
                    },
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // About Facilities page
        'page_template_template_about_facilities': {
            init: function () {

                (function () {
                    var photo_swiper = new Swiper('#space-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: true,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        }
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // About History page
        'page_about_history': {
            init: function () {

                (function () {
                    var swiper_2000 = new Swiper('#history-2000 .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: false,
                        speed: 1200,
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        slidesOffsetAfter: 150,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        pagination: '.pagination-2000',
                        paginationClickable: true,
                        nextButton: '.next-2000',
                        prevButton: '.prev-2000',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        onPaginationRendered: function () {
                            var date_array = [];
                            $('#history-2000 .swiper-slide').each(function () {
                                var date = $(this).data('year');
                                date_array.push(date);
                            });
                            $('.pagination-2000 .swiper-pagination-bullet').each(function (key) {
                                $(this).attr('data-key', key);
                                $(this).text(date_array[key]);
                            });
                        },
                    });
                    var swiper_1900 = new Swiper('#history-1900 .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: false,
                        speed: 1200,
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        slidesOffsetAfter: 150,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        pagination: '.pagination-1900',
                        paginationClickable: true,
                        nextButton: '.next-1900',
                        prevButton: '.prev-1900',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        onPaginationRendered: function () {
                            var date_array = [];
                            $('#history-1900 .swiper-slide').each(function () {
                                var date = $(this).data('year');
                                date_array.push(date);
                            });
                            $('.pagination-1900 .swiper-pagination-bullet').each(function (key) {
                                $(this).attr('data-key', key);
                                $(this).text(date_array[key]);
                            });
                        },
                    });
                    var swiper_1800 = new Swiper('#history-1800 .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: false,
                        speed: 1200,
                        effect: 'fade',
                        fade: {
                            crossFade: true,
                        },
                        slidesOffsetAfter: 150,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        pagination: '.pagination-1800',
                        paginationClickable: true,
                        nextButton: '.next-1800',
                        prevButton: '.prev-1800',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        onPaginationRendered: function () {
                            var date_array = [];
                            $('#history-1800 .swiper-slide').each(function () {
                                var date = $(this).data('year');
                                date_array.push(date);
                            });
                            $('.pagination-1800 .swiper-pagination-bullet').each(function (key) {
                                $(this).attr('data-key', key);
                                $(this).text(date_array[key]);
                            });
                        },
                    });

                    function date_line_left_width_2000() {
                        var datebox_offset = $('#history-2000 .date-box').position().left;
                        var line_width = datebox_offset - $(window).width() / 2;
                        line_width = line_width + 100;
                        $('#history-2000 .date-line').css({'width': line_width + 'px'});
                    }

                    function date_line_left_width_1800() {
                        var datebox_offset = $('#history-1800 .date-box').position().left;
                        var line_width = datebox_offset - $(window).width() / 2;
                        line_width = line_width + 100;
                        $('#history-1800 .date-line').css({'width': line_width + 'px'});
                    }

                    function date_line_right_width() {
                        var center_line_offset = $('.history-slider.right .down-line').position().left;
                        var difference = center_line_offset - 80;
                        $('.history-slider.right .date-line').css({'width': difference + 'px'});
                    }

                    $(window).on('resize', function () {
                        date_line_left_width_2000();
                        date_line_left_width_1800();
                        date_line_right_width();
                    });

                    $('#history-2000').each(function (e) {
                        var box_left = $(this);
                        var waypoint_box_left = new Waypoint({
                            element: box_left[0],
                            handler: function (direction) {
                                if (direction === 'down') {
                                    box_left.addClass('on');
                                    date_line_left_width_2000();
                                }
                            },
                            offset: '50%'
                        });
                    });

                    $('#history-1800').each(function (e) {
                        var box_left = $(this);
                        var waypoint_box_left = new Waypoint({
                            element: box_left[0],
                            handler: function (direction) {
                                if (direction === 'down') {
                                    box_left.addClass('on');
                                    date_line_left_width_1800();
                                }
                            },
                            offset: '50%'
                        });
                    });

                    $('#history-1900').each(function (e) {
                        var box_right = $(this);
                        var waypoint_box_right = new Waypoint({
                            element: box_right[0],
                            handler: function (direction) {
                                if (direction === 'down') {
                                    box_right.addClass('on');
                                    date_line_right_width();
                                }
                            },
                            offset: '50%'
                        });
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Study Abroad page
        'page_template_template_study_abroad': {
            init: function () {

                function initialize() {
                    var latlng = new google.maps.LatLng(42.050293, -87.6844456);
                    var styles = [{
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "administrative.country",
                        "elementType": "geometry.fill",
                        "stylers": [{"saturation": "17"}]
                    }, {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [{"color": "#eeebf3"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{"color": "#ffffff"}, {"visibility": "on"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [{"saturation": -100}, {"lightness": 45}]
                    }, {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [{"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [{"color": "#4e2a84"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [{"color": "#dad2e5"}]
                    }, {
                        "featureType": "transit.line",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "transit.station",
                        "elementType": "icon",
                        "stylers": [{"color": "#000"}, {"visibility": "off"}]
                    }, {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [{"color": "#b7a8cd"}, {"visibility": "on"}]
                    }];
                    var styledMap = new google.maps.StyledMapType(styles);

                    var myOptions =
                        {
                            center: new google.maps.LatLng(42.050293, -87.6844456),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var map = new google.maps.Map(document.getElementById("map-abroad-office"), myOptions);

                    var myMarker = new google.maps.Marker(
                        {
                            position: latlng,
                            icon: 'data:image/png;base64,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',
                            map: map,
                        });

                    map.mapTypes.set('map_style', styledMap);
                    map.setMapTypeId('map_style');
                    myMarker.setMap(map);
                }

                initialize();


            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Contact page
        'page_contact': {
            init: function () {
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Box Office page
        'page_template_template_box_office': {
            init: function () {

                function initialize() {
                    var latlng = new google.maps.LatLng(42.0527046, -87.6743886);
                    var latlng2 = new google.maps.LatLng(42.0517463, -87.6736829);
                    var latlng3 = new google.maps.LatLng(42.0521894, -87.6736206);
                    var latlng4 = new google.maps.LatLng(42.0517463, -87.6736829);
                    var latlng5 = new google.maps.LatLng(42.0517463, -87.6736829);
                    var styles = [{
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "administrative.country",
                        "elementType": "geometry.fill",
                        "stylers": [{"saturation": "17"}]
                    }, {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [{"color": "#eeebf3"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{"color": "#ffffff"}, {"visibility": "on"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [{"saturation": -100}, {"lightness": 45}]
                    }, {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [{"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [{"color": "#4e2a84"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [{"color": "#dad2e5"}]
                    }, {
                        "featureType": "transit.line",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "transit.station",
                        "elementType": "icon",
                        "stylers": [{"color": "#000"}, {"visibility": "off"}]
                    }, {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [{"color": "#b7a8cd"}, {"visibility": "on"}]
                    }];
                    var styledMap = new google.maps.StyledMapType(styles);

                    var myOptions =
                        {
                            center: new google.maps.LatLng(42.0527046, -87.6743886),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var myOptions2 =
                        {
                            center: new google.maps.LatLng(42.0527046, -87.6743886),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var myOptions3 =
                        {
                            center: new google.maps.LatLng(42.0527046, -87.6743886),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var myOptions4 =
                        {
                            center: new google.maps.LatLng(42.0527046, -87.6743886),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var myOptions5 =
                        {
                            center: new google.maps.LatLng(42.0527046, -87.6743886),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var map = new google.maps.Map(document.getElementById("map-ticket-office"), myOptions);
                    var map2 = new google.maps.Map(document.getElementById("map-performance-venue"), myOptions2);
                    var map3 = new google.maps.Map(document.getElementById("map-pick-staiger-hall"), myOptions3);
                    var map4 = new google.maps.Map(document.getElementById("map-regenstein-hall"), myOptions4);
                    var map5 = new google.maps.Map(document.getElementById("map-parking"), myOptions5);

                    var myMarker = new google.maps.Marker(
                        {
                            position: latlng,
                            icon: 'data:image/png;base64,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',
                            map: map,
                        });

                    var myMarker2 = new google.maps.Marker(
                        {
                            position: latlng2,
                            icon: 'data:image/png;base64,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',
                            map: map2,
                        });

                    var myMarker3 = new google.maps.Marker(
                        {
                            position: latlng3,
                            icon: 'data:image/png;base64,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',
                            map: map3,
                        });

                    var myMarker4 = new google.maps.Marker(
                        {
                            position: latlng4,
                            icon: 'data:image/png;base64,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',
                            map: map4,
                        });

                    var myMarker5 = new google.maps.Marker(
                        {
                            position: latlng5,
                            icon: 'data:image/png;base64,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',
                            map: map5,
                        });

                    map.mapTypes.set('map_style', styledMap);
                    map.setMapTypeId('map_style');
                    myMarker.setMap(map);

                    map2.mapTypes.set('map_style', styledMap);
                    map2.setMapTypeId('map_style');
                    myMarker2.setMap(map2);

                    map3.mapTypes.set('map_style', styledMap);
                    map3.setMapTypeId('map_style');
                    myMarker3.setMap(map3);

                    map4.mapTypes.set('map_style', styledMap);
                    map4.setMapTypeId('map_style');
                    myMarker4.setMap(map4);

                    map5.mapTypes.set('map_style', styledMap);
                    map5.setMapTypeId('map_style');
                    myMarker5.setMap(map5);

                }

                initialize();


            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Student Life page
        'page_template_template_student_life': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // International Prizes Detail page
        'page_template_template_about_international_prizes_detail': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#photo-content-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: true,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // International Prizes Detail 2 page
        'page_template_template_about_international_prizes_detail2': { //What is this for? - SM
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#photo-content-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: true,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Student Advising page
        'page_template_template_resources_students_advising': {
            init: function () {


                function initialize() {
                    var latlng = new google.maps.LatLng(42.0517503, -87.6736776);
                    var styles = [{
                        "featureType": "administrative",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "administrative.country",
                        "elementType": "geometry.fill",
                        "stylers": [{"saturation": "17"}]
                    }, {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [{"color": "#eeebf3"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [{"color": "#ffffff"}, {"visibility": "on"}]
                    }, {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [{"saturation": -100}, {"lightness": 45}]
                    }, {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [{"color": "#4e2a84"}]
                    }, {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [{"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [{"color": "#4e2a84"}, {"visibility": "on"}]
                    }, {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [{"color": "#dad2e5"}]
                    }, {
                        "featureType": "transit.line",
                        "stylers": [{"color": "#543288"}, {"visibility": "on"}]
                    }, {
                        "featureType": "transit.station",
                        "elementType": "icon",
                        "stylers": [{"color": "#000"}, {"visibility": "off"}]
                    }, {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [{"color": "#b7a8cd"}, {"visibility": "on"}]
                    }];
                    var styledMap = new google.maps.StyledMapType(styles);

                    var myOptions =
                        {
                            center: new google.maps.LatLng(42.0517503, -87.6736776),
                            zoom: 15,
                            mapTypeControlOptions: {
                                mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style']
                            },
                            panControl: false,
                            zoomControl: false,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            overviewMapControl: false
                        };

                    var map = new google.maps.Map(document.getElementById("student-office-map"), myOptions);

                    var myMarker = new google.maps.Marker(
                        {
                            position: latlng,
                            icon: 'data:image/png;base64,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',
                            map: map,
                        });

                    map.mapTypes.set('map_style', styledMap);
                    map.setMapTypeId('map_style');
                    myMarker.setMap(map);

                }

                initialize();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // News page
        'page_news': {
            init: function () {

                (function () {
                    var news_swiper = new Swiper('.slider-banner .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: true,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        nextButton: '.next',
                        prevButton: '.prev',
                        pagination: '.progress-bar',
                        paginationType: 'progress',
                        breakpoints: {},
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                    });
                    var pdf_swiper = new Swiper('#pdf-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.5,
                        loop: $('#pdf-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        centeredSlides: true,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.pdf-next',
                        prevButton: '.pdf-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.5,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // News Detail page
        'page_node_type_article': {
            init: function () {

                (function () {
                    var news_swiper = new Swiper('#photo-content-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: $('#photo-content-slider .swiper-container .swiper-slide').length > 1 ? true : false,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 0,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        pagination: '.pagination',
                        paginationClickable: true,
                        breakpoints: {},
                    });
                    var related_swiper = new Swiper('#related-news-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.5,
                        loop: $('#related-news-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        centeredSlides: true,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.pdf-next',
                        prevButton: '.pdf-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.5,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Resources Alumni page
        'page_resources_alumni': {
            init: function () {

                //Make anything with an ID more modular. Should be classes - SM
                (function () {
                    var photo_swiper = new Swiper('#photo-content-slider. .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: $('#photo-content-slider .swiper-container .swiper-slide').length > 1 ? true : false,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {},
                    });

                    var pdf_swiper = new Swiper('#pdf-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.5,
                        loop: $('#pdf-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        centeredSlides: true,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.pdf-next',
                        prevButton: '.pdf-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.5,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Student Life page
        'page_template_template_about_institute_for_new_music': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#upcoming-events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#upcoming-events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.upcoming-next',
                        prevButton: '.upcoming-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                    var past_events_swiper = new Swiper('#photo-content-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 1,
                        loop: $('#photo-content-slider .swiper-container .swiper-slide').length > 1 ? true : false,
                        speed: 1200,
                        spaceBetween: 0,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {},
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // About Past Event Detail page
        'page_template_template_about_past_event_detail': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#upcoming-events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#upcoming-events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.upcoming-next',
                        prevButton: '.upcoming-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Student Resources page
        'page_template_template_resources_students': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#resources-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#resources-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // FAQ page
        'page_template_template_faq': {
            init: function () {

                $('.answer').each(function (i) {
                    var answer_array = new Array();
                    var answer = $('#answer-' + i);
                    answer_array.push(answer);
                    answer_array[1, 0].append('<a class="toggle" href="#"><span class="open">Show More</span><span class="close">Show Less</span></a>');

                    function createDots() {
                        answer_array[1, 0].dotdotdot({
                            after: 'a.toggle',
                            watch: "window"
                        });
                    }

                    function destroyDots(i) {
                        answer_array[1, 0].trigger('destroy');
                    }

                    createDots();

                    answer_array[1, 0].on(
                        'click',
                        'a.toggle',
                        function () {
                            answer_array[1, 0].toggleClass('opened');
                            if (answer_array[1, 0].hasClass('opened')) {
                                destroyDots();
                            }
                            else {
                                createDots();
                            }
                            return false;
                        }
                    );
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Financial Aid Scholarship page
        'page_template_template_financial_aid_scholarships': {
            init: function () {

                $('.tabbed-table .tab-link').on('click', function (event) {
                    event.preventDefault();
                    var tab = $(this).attr('href');
                    if (!$(this).hasClass('active')) {
                        $(tab).slideDown(300);
                        $(this).addClass('active');
                    }
                    else {
                        $(tab).slideUp(300);
                        $(this).removeClass('active');
                    }
                });

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Concerts Events page
        'page_events': {
            init: function () {

                (function () {
                    //Moved these functions to the common / general init.
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Brass page
        'page_template_template_brass': {
            init: function () {

                (function () {
                    var featured_events_swiper = new Swiper('#davee-media-library .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#davee-media-library .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.davee-next',
                        prevButton: '.davee-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                    var related_events_swiper = new Swiper('#related-events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#related-events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.related-next',
                        prevButton: '.related-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Faculty Detail page
        'page_node_type_faculty_details': {
            init: function () {

                (function () {
                    var upcoming_events_swiper = new Swiper('#events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });

                    var video_events_swiper = new Swiper('.video-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('.video-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.video-next',
                        prevButton: '.video-prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 2,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Ensembls Single page
        'page_template_template_performing_ensembles_single': {
            init: function () {

                (function () {
                    var events_swiper = new Swiper('#events-slider .swiper-container', {
                        autoplay: false,
                        slidesPerView: 3.33,
                        loop: $('#events-slider .swiper-container .swiper-slide').length > 3 ? true : false,
                        speed: 1200,
                        spaceBetween: 40,
                        simulateTouch: true,
                        queueStartCallbacks: true,
                        queueEndCallbacks: true,
                        loopAdditionalSlides: 1,
                        watchOverflow: true,
                        a11y: {
                            prevSlideMessage: 'Previous slide',
                            nextSlideMessage: 'Next slide'
                        },
                        nextButton: '.next',
                        prevButton: '.prev',
                        breakpoints: {
                            1280: {
                                slidesPerView: 2.33,
                            },
                            960: {
                                slidesPerView: 1.33,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            580: {
                                slidesPerView: 1,
                            },
                        },
                    });
                })();

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },


        // Single Event page
        'page_node_type_events': {
            init: function () {

                //initialize();

                //Grab the event on the page and add the to FullCalendar
                var calendarEvents = [];
                var thisEvent = new Date($(".event-details").data('date').replace('at ', '').slice(0, -2)); //Grab from data attribute near title
                var eventTitle = $('.header1').html(); //Grab the title of the page

                if (thisEvent !== undefined) {
                    calendarEvents.push({
                        title: eventTitle,
                        start: thisEvent,
                        end: thisEvent
                    });
                }


                if ($(".more-dates").length > 0) {
                    $(".more-dates li a").each(function () {
                        var event = new Date($(this).data('date').replace('at ', '').slice(0, -2));

                        calendarEvents.push({
                            title: eventTitle,
                            start: event.toISOString(),
                            end: event.toISOString()
                        });
                    });

                    $(".more-dates li a").bind('click', function () {
                        var currentClickDate = $(this).data('date');
                        $(".event-details,.location-wrapper").addClass('hidden');
                        $(".event-details[data-date='" + currentClickDate + "']").removeClass('hidden');
                        $(".location-wrapper[data-date='" + currentClickDate + "']").removeClass('hidden');
                    });


					$(document).ready(function () {

						var $_GET = {};

						document.location.search.replace(/\??(?:([^=]+)=([^&]*)&?)/g, function () {
							function decode(s) {
								return decodeURIComponent(s.split("+").join(" "));
							}

							$_GET[decode(arguments[1])] = decode(arguments[2]);
						});

						if($_GET["eventdate"] && $(".more-dates li a")) {
							console.log($_GET["eventdate"]);
							var currentClickDate = $_GET["eventdate"];
							var linkDate = moment.unix(currentClickDate).format("MMMM D, YYYY \\a\\t h:mma");
							console.log(linkDate);
							$(".event-details,.location-wrapper").addClass('hidden');
							$(".event-details[data-date='" + linkDate + "']").removeClass('hidden');
							$(".location-wrapper[data-date='" + linkDate + "']").removeClass('hidden');
						}
					});

                }

                var $calendar = $("#event-single-calendar");
                $calendar.fullCalendar({
                    header: {
                        left: 'prev',
                        center: 'title',
                        right: 'next'
                    },
                    weekends: true,
                    allDaySlot: true,
                    droppable: true,
                    timezone: false,
                    events: calendarEvents,
                    eventAfterAllRender: function (view) {
                    },
                    eventRender: function (event, e) {
                        $(e).addClass(event.category);

                        var eventStart = moment(event.start);
                        var eventEnd = event._end === null ? eventStart : moment(event.end);
                        var diffInDays = eventEnd.diff(eventStart, 'days');
                        if (!$("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-past')) {
                            if (!$("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                                $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                                for (var i = 1; i < diffInDays; i++) {
                                    eventStart.add(1, 'day');
                                    $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                                }
                            }
                        }
                        if ($("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                            $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                            for (var i = 1; i < diffInDays; i++) {
                                eventStart.add(1, 'day');
                                $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                            }
                        }
                    },
                    dayClick: function (date, jsEvent, view) {
                        //console.log(date);
                    },
                    eventAfterRender: function (event, element) {
                        if (calendarEvents.length <= 1) {
                            // $("td[data-date='" + eventStart.format('YYYY-MM-DD') +
                            // "']").css('cursor','default');
                            $("a.fc-day-grid-event.fc-event, td.has-events .fc-day-number").css('cursor', 'default');
                        }
                    },
                    eventClick: function (calEvent, jsEvent, view) {
                        if ($(".more-dates") > 0) {
                            var currentClickDate = calEvent.start;
                            $(".event-details").addClass('hidden');
                            $(".event-details[data-date='" + moment(currentClickDate).format("MMMM D, Y [at] h:mm") + "']").removeClass('hidden');
                        }
                    }
                });

                //Make it default to the event's month.
                $calendar.fullCalendar('gotoDate', moment(calendarEvents[0].start));

                //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
                $('#event-single-calendar table').addClass('calendar-table');

            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },

      /**
       * Calendar Page
       */
      'page_events_calendar': {
        init: function () {

          var date = new Date();
          var d = date.getDate();
          var m = date.getMonth();
          var y = date.getFullYear();
          var day_was_clicked = false;
          var dayClicked;

          $.getJSON('/get_events/event_resource?_format=json', function (data) {
          })
            .fail(function () {
              console.log("error");
            })
            .success(function (data) {
              function setCalendarListHeight() {
                if ($('#events-calendar').hasClass('list-view')) {
                  var aside_height = $('aside').height() + 250;
                  var list_height = $('.list-events').height() + 350;
                  if (list_height > aside_height) {
                    $('.list-view').css('height', list_height);
                  }
                  else {
                    $('.list-view').css('height', aside_height);
                  }
                }
              }

              /**
               * Render List View
               */
              function renderListView(day_was_clicked, dayClicked, month_view_date) {
                var event_contents = '<div class="events-wrapper">';

                // Check Top Filters
                var top_vals = [];
                $('#filters input:checked').each(function () {
                  top_vals.push($(this).val());
                });

                // Check Aside Filters
                var aside_vals = [];
                $('#aside-filters input:checked').each(function () {
                  aside_vals.push($(this).val());
                });

                // Todays Date

                var cDate = new Date();
                var dateMOne = cDate.setHours(cDate.getHours()-1);
                var ntoday = moment(dateMOne).format();

                // Events
                //Sorted by date. List view posts them out of order sometimes.
                // - SM
                newEvents.sort(function (left, right) {
                  return moment.utc(left.start).diff(moment.utc(right.start))
                });

                for (var key in newEvents) {

                  var eventStart = newEvents[key].start.valueOf();
                  //var eventEnd = moment(newEvents[key].end).valueOf(); -- Does not exist?
                  var subcatStatus = false;
                  var maincatStatus = false;
                  var currentMainEventCategory = '';

                  // check if it is current event
                  if (eventStart > ntoday) {

                    // check main category
                    var maincats = newEvents[key].category.split(" ");

                    for (i = 0; i < maincats.length; i++) {
                      if (top_vals.indexOf(maincats[i]) !== -1) {
                        maincatStatus = true;

                        if(!currentMainEventCategory)
                          currentMainEventCategory = maincats[i];
                      }
                    }

                    // check sub category
                    var res = newEvents[key].subcat.split(" ");

                    for (i = 0; i < res.length; i++) {
                      if (aside_vals.indexOf(res[i]) !== -1) {
                        subcatStatus = true;
                      }
                    }

                    if(!subcatStatus || !maincatStatus){
                      continue;
                    }
                    var eventStartDate = moment(newEvents[key].start).format("MMMM DD, YYYY h:mmA");
                    var eventDataDate = moment(newEvents[key].start);
                    eventDataDate = eventDataDate.add(1, 'day');
                    //var eventEndDate = moment(newEvents[key].end).format("MMMM DD, YYYY h:mmA"); - Does not exist
                    var checkEvent = moment(eventDataDate).format("YYYY-MM-DD");
                    var monthDate = moment(month_view_date).format("YYYY-MM-DD");
                    var eventTitle = newEvents[key].title;
                    var eventCategory = newEvents[key].category.split(" ")[0];
                    var eventSubCategory = newEvents[key].subcat;
                    var eventLocation = newEvents[key].location;
                    var eventThumb = newEvents[key].thumb;
                    var eventUrl = newEvents[key].url;
                    //var eventIsSubscription = newEvents[key].is_subscription;
                    //var eventSubscriptionName = newEvents[key].subscription_name;
                    var eventTicketUrl = newEvents[key].ticket_url;

                    var eventTicketSrc = "";

                    //Is this a free event?
                    if ((newEvents[key].free_event === true)) {
                      eventTicketSrc = '<a href="' + eventUrl + '" class="purple-btn" title="Learn more about this free event">Free Event</a>';
                    }

                    //Are ticket buttons hidden?
                    if (newEvents[key].button_disabled === false) {
                      //Is this event sold out?
                      if (newEvents[key].sold_out === true) {
                        eventTicketSrc = '<a class="purple-btn" style="cursor:not-allowed;opacity:0.8;" aria-disabled="true" title="This event is sold out">Sold Out</a>';
                      }
                      else {
                        //Does this event have a ticket url?
                        if(eventTicketUrl !== "") {
                          //Is this a sub?
                          /*if(eventIsSubscription) {
eventTicketSrc = '<a href="' + eventTicketUrl + '" class="purple-btn" target="_blank" title="Purchase a subscription">Subscribe</a>';
} else {*/
                          eventTicketSrc = '<a href="' + eventTicketUrl + '" class="purple-btn" target="_blank" title="Purchase tickets for this event">Buy Tickets</a>';
                          //}
                        }
                      }
                    }


                    if(currentMainEventCategory){
                      eventCategory = currentMainEventCategory;
                    }

                    if (eventCategory.match('festivals-series')) {
                      var eventColor = 'yellow';
                      var eventTypeText = 'Festivals & Series';
                    }
                    if (eventCategory.match('recitals-lecture')) {
                      var eventColor = 'blue';
                      var eventTypeText = 'Recitals & Lectures';
                    }
                    if (eventCategory.match('bienen-ensembles')) {
                      var eventColor = 'violet';
                      var eventTypeText = 'Bienen Ensembles';
                    }
                    if (eventCategory.match('student-recitals')) {
                      var eventColor = 'green';
                      var eventTypeText = 'Student Recitals';
                    }

                    console.log(checkEvent);
                    if (month_view_date) {
                      if (checkEvent > monthDate) {
                        event_contents += '<div class="event" data-date="' + eventDataDate + '" data-category="all ' + eventCategory + ' ' + eventSubCategory + '">' +
                          '<div class="row">' +
                          '<div class="col-xs-5">' +
                          '<div class="thumb-wrap"><div class="thumb" style=\'background:url("' + eventThumb + '") 50% no-repeat;\'><a href="' + eventUrl + '" title="View event '+ eventTitle +'"></a></div><span class="cat ' + eventColor + '">' + eventTypeText + '</span></div>' +
                          '</div>' +
                          '<div class="col-xs-7">' +
                          '<div class="cnt">' +
                          '<p class="date">' + eventStartDate + '</p>' +
                          '<p class="event-title"><a href="' + eventUrl + '" class="body-link"><span>' + eventTitle + '</span></a></p>' +
                          '<p class="location">' + eventLocation + '</p>' +
                          '<div class="event-btns">' +
                          eventTicketSrc +
                          '<a href="' + eventUrl + '" class="btn">More Info</a>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>';
                      }

                      //console.log(event_contents);
                    }
                    else {
                      event_contents += '<div class="event" data-date="' + eventDataDate + '" data-category="all ' + eventCategory + ' ' + eventSubCategory + '">' +
                        '<div class="row">' +
                        '<div class="col-xs-5">' +
                        '<div class="thumb-wrap"><div class="thumb" style=\'background:url("' + eventThumb + '") 50% no-repeat;\'><a href="' + eventUrl + '" title="View event '+ eventTitle +'"></a></div><span class="cat ' + eventColor + '">' + eventTypeText + '</span></div>' +
                          '</div>' +
                        '<div class="col-xs-7">' +
                        '<div class="cnt">' +
                        '<p class="date">' + eventStartDate + '</p>' +
                        '<p class="event-title"><a href="' + eventUrl + '" class="body-link"><span>' + eventTitle + '</span></a></p>' +
                        '<p class="location">' + eventLocation + '</p>' +
                        '<div class="event-btns">' +
                        eventTicketSrc +
                        '<a href="' + eventUrl + '" class="btn">More Info</a>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                        '</div>';
                    }

                  }
                }

                event_contents += "</div>";

                $('#calendar .fc-view-container').hide();
                $(".list-events").html(event_contents);

                // No Events
                if ($('#events-calendar').hasClass('list-view')) {
                  if ($('.list-events .events-wrapper .event').length < 1) {
                    $('.no-events').show();
                  }
                  else {
                    $('.no-events').hide();
                  }
                }

                // Sidebar
                if ($('aside').length > 0) {
                  $('aside > *').each(function (e) {
                    var aside = $(this);
                    var waypoint_aside = new Waypoint({
                      element: aside[0],
                      handler: function (direction) {
                        if (direction === 'down') {
                          aside.addClass('on');
                        }
                      },
                      offset: '100%'
                    });
                  });
                }

                // Article
                if ($('.events-wrapper').length > 0) {
                  $('.events-wrapper > *').not('form').each(function (e) {
                    var article = $(this);
                    var waypoint_article = new Waypoint({
                      element: article[0],
                      handler: function (direction) {
                        if (direction === 'down') {
                          article.addClass('on');
                        }
                      },
                      offset: '100%'
                    });
                  });
                }
              }

              // Return Filters
              function filter(event) {
                var vals = [];
                $('#filters input:checked').each(function () {
                  vals.push($(this).val());
                });

                return vals.indexOf(event.category.split(" ")[0]) !== -1;
              }

              var newEvents = [];

              //Grab drupal data
              for (var i = 0; i < data.length; i++) {

                if ((data[i].repeat_event[0].value === true)) {

                  //Reoccurring event!
                  var eventItem = data[i];
                  var eventDate = data[i].event_data.field_event_date[0].value;
                  var eventTitle = data[i].title;
                  var eventLink = data[i].path[0].alias;
                  var eventDescription = data[i].event_data.field_detail.length > 0 ? data[i].event_data.field_detail[0].value : "";
                  //var eventType = [];
                  var eventTickets = "";
                  var eventInstance;
                  var eventParentInstance;
                  var eventFree = eventItem.event_data.field_free_event[0].value;
                  var eventSoldOut = eventItem.event_data.field_sold_out[0].value;
                  var eventButtonDisabled = eventItem.event_data.field_disable_ticket_button[0].value;
                  var eventLocation;
                  var eventTagline = "";
                  var eventPricing = "";
                  var eventImage = 'https://music.northwestern.edu/sites/default/files/default_images/default_event.jpg';

                  if (eventItem.event_data.field_ticket_link.length > 0) {
                    eventTickets = String(eventItem.event_data.field_ticket_link[0].uri);
                  }

                  /*
                  If price is available, display the price. Even on Free events.
                  */
                  if (eventItem.event_pricing) {
                    eventPricing = eventItem.event_pricing[0].value;
                  }
                  else {
                    eventPricing = ""; //Add text maybe?
                  }

                  /*
                  If this event is a child event in patron manager, get this
                  ID
                  */
                  if (eventItem.event_data.field_instance_id.length > 0) {
                    eventInstance = String(eventItem.event_data.field_instance_id.value);
                  }

                  /*//If this is a parent event, get this id.
                  if (eventItem.event_id.length > 0) {
                  eventParentInstance = String(eventItem.event_id.value);
                  }*/

                  if (eventItem.event_data.field_event_instance_location.length > 0) {
                    var locationId = eventItem.event_data.field_event_instance_location.value;

                    switch (locationId) {
                      case "a0T46000000NjiOEAS":
                        eventLocation = "Cahn Auditorium";
                        break;
                      case "a0T46000000NjiJEAS":
                        eventLocation = "Pick-Staiger Concert Hall";
                        break;
                      case "a0T460000009f5VEAQ":
                        eventLocation = "McClintock Choral and Recital Room";
                        break;
                      case "a0T46000000NjiEEAS":
                        eventLocation = "Galvin Recital Hall";
                        break;
                      case "a0T460000009f5ALICE":
                        eventLocation = "Alice Millar Chapel";
                        break;
                      case "a0T460000009f5REGEN":
                        eventLocation = "Regenstein Master Class Room";
                        break;
                      case "a0T46000000LUTKIN":
                        eventLocation = "Lutkin Hall";
                        break;
                      case "a0T46000000RYAN":
                        eventLocation = "Ryan Opera Theater";
                        break;
                      default:
                        eventLocation = "";
                    }
                  }

                  if (eventItem.event_summary.length > 0) {
                    eventTagline = eventItem.event_summary.value;
                  }

                  if (data[i].featured_image.length > 0) {
                    var uri = data[i].featured_image[0].uri != null ? data[i].featured_image[0].uri[0].value.toString() : '';

                    eventImage = uri.replace('public://', '/sites/default/files/').replace(/"/g, '');
                  }

                  if (eventDate) {
                    var eventData = moment(eventDate);
                    var eventTime = eventData._i;
                    //To compensate for UTC. Date fields should be set to
                    // "none" and master site timezone to UTC.
                  }
                  else {
                    var eventTime = Date.now();
                  }

                  //Get main and sub cats
                  if (data[i].event_type.length > 0) {
                    //Lets remove dupes
                    var uniqueNames = [];
                    var eventType = [];
                    var eventSubCategories = [];

                    $.each(data[i].event_type, function (i, el) {
                      if ($.inArray(el, uniqueNames) === -1) {
                        uniqueNames.push(el);
                      }
                    });

                    for (var e = 0; e < uniqueNames.length; e++) {
                      var category = String(uniqueNames[e]);

                      switch (category) {
                        case "Bienen Ensembles":
                          eventType.push("Bienen Ensembles");
                          break;
                        case "Festivals & Series":
                          eventType.push("Festivals & Series");
                          break;
                        case "Recitals & Lectures":
                          eventType.push("Recitals & Lectures");
                          break;
                        case "Student Recitals":
                          eventType.push("Student Recitals");
                          eventSubCategories.push("Student Recitals");
                          break;
                        default:
                          eventSubCategories.push(category);
                      }
                    }

                  } else { //Add to default category if there is no event
                    var eventType = [];
                    eventType.push("Bienen Ensembles");
                  }

                  newEvents.push({
                    title: eventTitle,
                    tagline: eventTagline,
                    start: eventTime,
                    category: eventType.toString().replace(/&/g, "").replace(/\s+/g, '-').toLowerCase().replace(/,/g, " "),
                    subcat: eventSubCategories.toString().replace(/&/g, "").replace(/\s+/g, '-').toLowerCase().replace(/,/g, " "),
                    location: eventLocation,
                    thumb: eventImage,
                    url: eventLink,
                    ticket_url: eventTickets,
                    description: eventDescription,
                    instance_id: eventInstance,
                    parent_event_id: eventParentInstance,
                    sold_out: eventSoldOut,
                    free_event: eventFree,
                    button_disabled: eventButtonDisabled,
                    modalNumber: i,
                    pricing: eventPricing
                  });


                }
                else { //Single instance

                  var eventItem = data[i];
                  //var eventDate = data[i].event_date;
                  //var eventType = [];
                  var eventTickets = "";
                  var eventInstance;
                  var eventParentInstance;
                  var eventFree = false;
                  var eventSoldOut = false;
                  var eventButtonDisabled = false;
                  var eventLocation;
                  var eventSubCategories = [];
                  var eventTagline = "";
                  var eventPricing;
                  var eventDescription = "";
                  //var eventIsSubscription = eventItem.event_subscription[0].value;
                  //var eventSubscriptionName = eventItem.event_subscription_name.value;
                  var eventImage = 'https://music.northwestern.edu/sites/default/files/default_images/default_event.jpg';

                  if (eventItem.ticket_link.length > 0) {
                    eventTickets = String(eventItem.ticket_link[0].uri);
                  }

                  if (eventItem.free_event.length > 0) {
                    eventFree = eventItem.free_event[0].value;
                  }

                  if (eventItem.sold_out.length > 0) {
                    eventSoldOut = eventItem.sold_out[0].value;
                  }

                  if (eventItem.disable_ticket_button.length > 0) {
                    eventButtonDisabled = eventItem.disable_ticket_button[0].value;
                  }

                  //If this event is a child event in patron manager, get this
                  // ID
                  if (eventItem.event_instance_id.length > 0) {
                    eventInstance = String(eventItem.event_instance_id[0].value);
                  }

                  //If this is a parent event, get this id.
                  if (eventItem.event_id.length > 0) {
                    eventParentInstance = String(eventItem.event_id[0].value);
                  }

                  if (eventItem.event_location.length > 0) {
                    var locationId = eventItem.event_location[0].value;

                    switch (locationId) {
                      case "a0T46000000NjiOEAS":
                        eventLocation = "Cahn Auditorium";
                        break;
                      case "a0T46000000NjiJEAS":
                        eventLocation = "Pick-Staiger Concert Hall";
                        break;
                      case "a0T460000009f5VEAQ":
                        eventLocation = "McClintock Choral and Recital Room";
                        break;
                      case "a0T46000000NjiEEAS":
                        eventLocation = "Galvin Recital Hall";
                        break;
                      case "a0T460000009f5ALICE":
                        eventLocation = "Alice Millar Chapel";
                        break;
                      case "a0T460000009f5REGEN":
                        eventLocation = "Regenstein Master Class Room";
                        break;
                      case "a0T46000000LUTKIN":
                        eventLocation = "Lutkin Hall";
                        break;
                      case "a0T46000000RYAN":
                        eventLocation = "Ryan Opera Theater";
                        break;
                      default:
                        eventLocation = "";
                        break;
                    }
                  }

                  if(eventItem.body.length > 0) {
                    eventDescription = eventItem.body[0].value;
                  }

                  if (eventItem.event_summary.length > 0) {
                    eventTagline = eventItem.event_summary[0].value;
                  }

                  if (eventFree) {
                    if (eventItem.event_pricing.length > 0) {
                      eventPricing = eventItem.event_pricing[0].value;
                    }
                    else {
                      eventPricing = ""; //Add text?
                    }
                  }
                  else {
                    if (eventItem.event_pricing.length > 0) {
                      eventPricing = eventItem.event_pricing[0].value;
                    }
                    else {
                      eventPricing = "";
                    }
                  }


                  if (data[i].featured_image.length > 0) {
                    var uri = data[i].featured_image[0].uri != null ? data[i].featured_image[0].uri[0].value.toString() : '';
                    eventImage = uri.replace('public://', '/sites/default/files/').replace(/"/g, '');
                  }

                  if (eventItem.event_date.length > 0) {

                    var eventData = moment(data[i].event_date[0].value);
                    var eventTime = eventData._i;
                    //To compensate for UTC. Date fields should be set to
                    // "none" and master site timezone to UTC.
                  }
                  else {
                    var eventTime = Date.now();
                  }

                  //Get main and sub cats
                  if (data[i].event_type.length > 0) {
                    //Lets remove dupes
                    var uniqueNames = [];
                    var eventType = [];
                    var eventSubCategories = [];

                    $.each(data[i].event_type, function (i, el) {
                      if ($.inArray(el, uniqueNames) === -1) {
                        uniqueNames.push(el);
                      }
                    });

                    for (var e = 0; e < uniqueNames.length; e++) {
                      var category = uniqueNames[e];

                      switch (category) {
                        case "Bienen Ensembles":
                          eventType.push("Bienen Ensembles");
                          break;
                        case "Festivals & Series":
                          eventType.push("Festivals & Series");
                          break;
                        case "Recitals & Lectures":
                          eventType.push("Recitals & Lectures");
                          break;
                        case "Student Recitals":
                          eventType.push("Student Recitals");
                          eventSubCategories.push("Student Recitals");
                          break;
                        default:
                          eventSubCategories.push(category);
                      }
                    }
                  } else { //Add to default category if there is no event
                    var eventType = [];
                    eventType.push("Bienen Ensembles");
                  }

                  newEvents.push({
                    title: eventItem.title[0].value,
                    tagline: eventTagline,
                    start: eventTime,
                    category: eventType.toString().replace(/&/g, "").replace(/\s+/g, '-').toLowerCase().replace(/,/g, " "),
                    subcat: eventSubCategories.toString().replace(/&/g, "").replace(/\s+/g, '-').toLowerCase().replace(/,/g, " "),
                    location: eventLocation,
                    thumb: eventImage,
                    url: eventItem.path[0].alias,
                    ticket_url: eventTickets,
                    description: eventDescription,
                    instance_id: eventInstance,
                    parent_event_id: eventParentInstance,
                    sold_out: eventSoldOut,
                    free_event: eventFree,
                    button_disabled: eventButtonDisabled,
                    pricing: eventPricing,
                    modalNumber: i,
                    //is_subscription: eventIsSubscription,
                    //subscription_name: eventSubscriptionName
                  });
                }
              }

              /**
               * Render Full Monthly Calendar
               */
              var $calendar = $("#calendar");
              $calendar.fullCalendar({
                header: {
                  left: '',
                  center: 'prev,next, title',
                  right: 'month,listDay'
                },
                weekends: true,
                allDaySlot: true,
                droppable: false,
                //events: newEvents,
                titleFormat: "MMMM 'YY",
                columnFormat: 'dddd',
                timeFormat: 'h:mmt',
                timezone: false,
                showNonCurrentDates: false,
                defaultView: 'month',
                eventAfterAllRender: function (view, isLoading) {

                  console.log("All events loaded");
                  $('div#loader-bar').addClass('hidden');
                  $('#mini-calendar, #aside-filters').removeClass('visually-hidden');

                  //Overlay for popup
                  $("div.shell").append('<div class="page-overlay hidden"></div>');

                  function closeEventModal() {
                    $(".page-overlay").addClass('hidden');
                    $(".event-modal").addClass('hidden');
                  }

                  //Keyboard exit if needed
                  //TODO: Fix this
                  document.onkeydown = function (evt) {
                    evt = evt || window.event;
                    if (evt.keyCode == 27) {
                      closeEventModal();
                    }
                  };

                  $("div.event-modal a.close").bind('click', function (e) {
                    e.preventDefault();
                    closeEventModal();
                  });

                  // Set View
                  var currentView = $('#calendar').fullCalendar('getView').name;
                  if (currentView == 'listDay') {
                    $('#calendar').parent().parent().removeClass('month-view');
                    $('#calendar').parent().parent().addClass('list-view');

                    // Keep both calendars sync'd
                    var month_view_date = $('#calendar').fullCalendar('getDate');
                    $("#mini-calendar").fullCalendar('gotoDate', month_view_date);
                  }
                  if (currentView == 'month') {
                    $('#calendar').parent().parent().addClass('month-view');
                    $('#calendar').parent().parent().removeClass('list-view');
                    $('#calendar .fc-view-container').show();
                    $(".list-events").html('');
                    $('#events-calendar').css('height', 'auto');
                    $('#mini-calendar .fc-content-skeleton .has-events span').removeClass('active');
                    day_was_clicked = false;
                    dayClicked = '';
                  }

                  // Create Header
                  var header = $calendar.find(".fc-header-toolbar");

                  // Insert Search Field
                  var searchHtml = document.createElement('div');
                  searchHtml.setAttribute("class", "searchblox");
                  var search_contents = '<form id="calendar-search" action="https://search.northwestern.edu/" method="get" role="search">\n' +
                    '<label class="hide-label" for="q-desktop">Search Concerts and Events</label>\n' +
                    '<input type="text" id="q-desktop" name="q" placeholder="Search all Concerts & Events"/>\n' +
                    '<input type="hidden" name="as_sitesearch" value="https://www.music.northwestern.edu/events/"/>\n' +
                    '<input type="hidden" name="sitetitle" value="Bienen School of Music Concerts & Events"/>\n' +
                    '<input type="submit" value="Search">\n' +
                    '</form>';

                  searchHtml.innerHTML = search_contents;
                  $calendar.find(".fc-left").html(search_contents);

                  // Insert Header Filters
                  if ($('#filters').length < 1) {
                    var filtersHtml = document.createElement('ul');
                    filtersHtml.setAttribute("id", "filters");
                    filtersHtml.setAttribute("class", "checkboxes");
                    var filter_contents = '<li class="filter-title">Upcoming</li><li>Filters:</li>' +
                      '<li><input type="checkbox" checked id="festivals-series" value="festivals-series" /><label class="festivals-series" for="festivals-series">Festivals & <br />Series</label></li>' +
                      '<li><input type="checkbox" checked id="recitals-visiting-artists" value="recitals-lectures" /><label class="recitals-visiting-artists" for="recitals-visiting-artists">Recitals & <br />Lectures</label></li>' +
                      '<li><input type="checkbox" checked id="bienen-ensembles" value="bienen-ensembles" /><label class="bienen-ensembles" for="bienen-ensembles">Bienen <br />Ensembles</label></li>' +
                      '<li><input type="checkbox" checked id="student-recitals" value="student-recitals" /><label class="student-recitals" for="student-recitals">Student <br />Recitals</label></li>';
                    filtersHtml.innerHTML = filter_contents;
                    $calendar.find(".fc-center").append(filtersHtml);
                  }

                  // Insert Button Classes
                  $('.fc-month-button').addClass('btn');
                  $('.fc-listDay-button').addClass('btn');
                  $('.fc-month-button').text('Calendar View');
                  $('.fc-listDay-button').text('List View');

                  // Trigger Current View
                  header.find('.fc-right').find('.fc-button').off('mouseup').on('mouseup', function () {
                    if (!$(this).hasClass('fc-listDay-button')) {
                      $calendar.data("view", '');
                    }
                  });
                  if ($('#calendar').fullCalendar('getView').name != 'listDay') {
                    header.find(".fc-listDay-button").removeClass('fc-state-active active');
                    $("#listDay").remove();
                  }
                  else {
                    renderListView(day_was_clicked, dayClicked, month_view_date);
                  }
                  setCalendarListHeight();

                  if ($(window).width() < 681) {
                    var windowWidth = $(window).width();
                    $('.fc-event').each(function () {
                      if ($(this).offset().left < windowWidth / 2) {
                        $(this).addClass('left');
                      }
                      else {
                        $(this).addClass('right');
                      }
                    });
                  }
                },
                eventRender: function (event, e, element) {

                  var eventCategory = event.category.split(" ")[0];

                  if (eventCategory.match('student-recitals')) {
                    var eventColor = 'green';
                    var eventTypeText = 'Student Recitals';
                  }
                  if (eventCategory.match('recitals-lectures')) {
                    var eventColor = 'blue';
                    var eventTypeText = 'Recitals & Lectures';
                  }
                  if (eventCategory.match('bienen-ensembles')) {
                    var eventColor = 'violet';
                    var eventTypeText = 'Bienen Ensembles';
                  }
                  if (eventCategory.match('festivals-series')) {
                    var eventColor = 'yellow';
                    var eventTypeText = 'Festivals & Series';
                  }

                  $(e).addClass(event.category.split(" ")[0]);
                  $(e).addClass(eventColor);
                  $(e).addClass('event-modal-' + event.modalNumber.toString());

                  var cDate = new Date();
                  var ntoday = cDate.setHours(cDate.getHours()-1);

                  var eventStart = moment(event.start);
                  var eventEnd = event._end === null ? eventStart : moment(event.end);
                  var diffInDays = eventEnd.diff(eventStart, 'days');

                  /*var ntoday = new Date().getTime();
                  var eventStart = moment(event.start).valueOf();
                  var eventEnd = moment(event.end).valueOf();
                  var diffInDays = eventEnd.diff(eventStart, 'days');*/

                  if (!$("#calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-past')) {
                    if (!$("#calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                      $("#calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                      for (var i = 1; i < diffInDays; i++) {
                        eventStart.add(1, 'day');
                        $("#calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                      }

                      var eventTicketSrc = "";

                      if (eventStart > ntoday) {
                        var popupHtml = document.createElement('div');
                        popupHtml.setAttribute('class', 'event-modal');
                        popupHtml.setAttribute('id', 'event-modal-' + event.modalNumber.toString());

                        //Is this a free event?
                        if (event.free_event) {
                          eventTicketSrc = '<a href="' + event.url + '" class="btn purple-btn" title="Learn more about this free event">Free Event</a>';
                        }

                        //Are ticket buttons disabled?
                        if (event.button_disabled === false) {
                          //Is event sold out?
                          if (event.sold_out === true) {
                            eventTicketSrc = '<a class="btn purple-btn" style="cursor:not-allowed;opacity:0.8;" aria-disabled="true" title="This event is sold out">Sold Out</a>';
                          }
                          else {
                            //Is there a ticket url?
                            if(event.ticket_url !== "") {
                              //Is this a sub?
                              /*if(eventIsSubscription) {
    eventTicketSrc = '<a href="' + event.url + '" class="purple-btn" target="_blank" title="Purchase a subscription">Subscribe</a>';
  } else {*/
                              eventTicketSrc = '<a href="' + event.url + '" class="purple-btn" target="_blank" title="Purchase tickets for this event">Buy Tickets</a>';
                              //}
                            }
                          }
                        }

                        if (event.tagline) {
                          var eventTagline = '<p>' + event.tagline + '</p>';
                        }
                        else {
                          var eventTagline = "";
                        }

                        if (event.pricing) {
                          var eventPricing = '<p>' + event.pricing + '</p>';
                        }
                        else {
                          var eventPricing = "";
                        }

                        var popup_contents = '<a href="#" class="close" title="Close this window"></a>' +
                          '<div class="row">' +
                          '<div class="col-xs-6">' +
                          '<div class="thumb" style=\'background:url("' + event.thumb + '") 50% no-repeat\'>' +
                          '<span class="cat ' + eventColor + '">' + eventTypeText + '</span>' +
                          '</div>' +
                          '<div class="hide-on-mobile">' +
                          eventPricing +
                          eventTicketSrc +
                          '</div>' +
                          '</div>' +
                          '<div class="col-xs-6">' +
                          '<p class="date">' + moment(event.start).format('MMM DD, YYYY h:mmA') + '</p>' +
                          '<h3 class="post-title">' + event.title + '</h3>' +
                          '<p class="location">' + event.location + '</p>' +
                          '<div class="excerpt">' +
                          '<span class="hide-on-mobile">' + eventTagline + '</span>' +
                          //'<p>' + event.description + '</p>' +
                          '<p><a class="body-link" href="' + event.url + '">More Information &gt;</a></p>' +
                          '<div class="hide-on-desktop">' +
                          eventPricing +
                          eventTicketSrc +
                          '</div>' +
                          '</div>' +
                          '</div>' +
                          '</div>';

                        popupHtml.innerHTML = popup_contents;
                        $("div.shell").append(popupHtml);

                        $("div.event-modal").addClass('hidden');
                      }
                    }
                  }

                  if (!event.end) {
                    if (eventStart < ntoday) {
                      e.addClass("past-event");
                      e.children().addClass("past-event");
                      //e.css('cursor', 'default');
                    }
                  }
                  else {
                    if (eventEnd < ntoday) {
                      e.addClass("past-event");
                      e.children().addClass("past-event");
                      //e.css('cursor', 'default');
                    }
                  }

                  //For items that will trigger a popup. All non-past items
                  if (eventStart > ntoday) {
                    e.on('click', function (event) {
                      event.preventDefault();
                    });
                  }

                  //console.log(event);
                  return filter(event);
                },
                dayClick: function (date, jsEvent, view) {

                },
                eventClick: function (calEvent, jsEvent, view) {
                  //this.preventDefault();

                  var eventStart = moment(calEvent.start);
                  var cDate = new Date();
                  var ntoday = cDate.setHours(cDate.getHours()-1);

                  if (eventStart > ntoday) {
                    if (!$('.event-modal').hasClass('hidden')) {
                      $('.event-modal').addClass('hidden');
                    }
                    if ($('#event-modal-' + calEvent.modalNumber.toString())) {
                      $('#event-modal-' + calEvent.modalNumber.toString()).removeClass('hidden');
                      $('.page-overlay').removeClass('hidden');
                    }
                  }

                },
                eventAfterRender: function (event, element) {
                  //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
                  $('#calendar table, #calendar .fc-content-skeleton table, #mini-calendar table, #mini-calendar .fc-content-skeleton table').addClass('calendar-table');
                }
              });

              $('#calendar').fullCalendar('addEventSource', newEvents);
              $('#calendar').fullCalendar('rerenderEvents');

              //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
              //$('#calendar table, #calendar .fc-content-skeleton table, #mini-calendar table, #mini-calendar .fc-content-skeleton table').addClass('calendar-table');

              /**
               * Mini Calendar
               */
              var $mini_calendar = $("#mini-calendar");
              $mini_calendar.fullCalendar({
                header: {
                  left: '',
                  center: 'title',
                  right: ''
                },
                weekends: true,
                allDaySlot: true,
                droppable: true,
                //events: newEvents,
                titleFormat: "MMMM YYYY",
                columnFormat: 'ddd',
                timeFormat: 'h:mmt',
                timezone: false,
                eventRender: function (event, e, view) {
                  $(e).addClass(event.category);

                  var eventStart = moment(event.start);
                  var eventEnd = event._end === null ? eventStart : moment(event.end);
                  var diffInDays = eventEnd.diff(eventStart, 'days');
                  if (!$("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-past')) {
                    if (!$("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                      $("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                      for (var i = 1; i < diffInDays; i++) {
                        eventStart.add(1, 'day');
                        $("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                      }
                    }
                  }
                  if ($("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                    $("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                    for (var i = 1; i < diffInDays; i++) {
                      eventStart.add(1, 'day');
                      $("#mini-calendar td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                    }
                  }
                },
                eventAfterRender: function (event, element) {
                  for (var i = 0; i < $(".fc-day-grid .fc-week").length; i++) {
                    $(".fc-week:eq(" + i + ")").css("z-index", ($(".fc-day-grid .fc-week").length - i));
                  }
                  // Keep both calendars sync'd
                  var month_view_date = $('#mini-calendar').fullCalendar('getDate');
                  $("#calendar").fullCalendar('gotoDate', month_view_date);
                  //renderListView(day_was_clicked, dayClicked, month_view_date);
                }
              });

              //Activate mini-calendar
              $('#mini-calendar').fullCalendar('addEventSource', newEvents);
              $('#mini-calendar').fullCalendar('rerenderEvents');

              /**
               * Calendar filters
               */
              $('#filters input').on('change', function () {
                if ($(this).prop('checked')) {
                  if ($(this).attr('id') == 'bienen-ensembles') {
                    $('#aside-filters #bienen-ensembles').prop('checked', true);
                    $('#aside-filters #bienen-ensembles').parent().parent().addClass('checked');
                    $('#aside-filters #bienen-ensembles').parent().find('ul li input').each(function () {
                      $(this).prop('checked', true);
                    });
                  }
                  if ($(this).attr('id') == 'festivals-series') {
                    $('#aside-filters #festivals-series').prop('checked', true);
                    $('#aside-filters #festivals-series').parent().parent().addClass('checked');
                    $('#aside-filters #festivals-series').parent().find('ul li input').each(function () {
                      $(this).prop('checked', true);
                    });
                  }
                  if ($(this).attr('id') == 'recitals-visiting-artists') {
                    $('#aside-filters #recitals-visiting-artists').prop('checked', true);
                    $('#aside-filters #recitals-visiting-artists').parent().parent().addClass('checked');
                    $('#aside-filters #recitals-visiting-artists').parent().find('ul li input').each(function () {
                      $(this).prop('checked', true);
                    });
                  }
                  if ($(this).attr('id') == 'student-recitals') {
                    $('#aside-filters #student-recitals').prop('checked', true);
                    $('#aside-filters #student-recitals').parent().parent().addClass('checked');
                    $('#aside-filters #student-recitals').parent().find('ul li input').each(function () {
                      $(this).prop('checked', true);
                    });
                  }
                }
                else {
                  if ($(this).attr('id') == 'bienen-ensembles') {
                    $('#aside-filters #bienen-ensembles').prop('checked', false);
                    $('#aside-filters #bienen-ensembles').parent().parent().removeClass('checked');
                    $('#aside-filters #bienen-ensembles').parent().find('ul li input').each(function () {
                      $(this).prop('checked', false);
                    });
                  }
                  if ($(this).attr('id') == 'festivals-series') {
                    $('#aside-filters #festivals-series').prop('checked', false);
                    $('#aside-filters #festivals-series').parent().parent().removeClass('checked');
                    $('#aside-filters #festivals-series').parent().find('ul li input').each(function () {
                      $(this).prop('checked', false);
                    });
                  }
                  if ($(this).attr('id') == 'recitals-visiting-artists') {
                    $('#aside-filters #recitals-visiting-artists').prop('checked', false);
                    $('#aside-filters #recitals-visiting-artists').parent().parent().removeClass('checked');
                    $('#aside-filters #recitals-visiting-artists').parent().find('ul li input').each(function () {
                      $(this).prop('checked', false);
                    });
                  }
                  if ($(this).attr('id') == 'student-recitals') {
                    $('#aside-filters #student-recitals').prop('checked', false);
                    $('#aside-filters #student-recitals').parent().parent().removeClass('checked');
                    $('#aside-filters #student-recitals').parent().find('ul li input').each(function () {
                      $(this).prop('checked', false);
                    });
                  }
                }
                $('#calendar').fullCalendar('rerenderEvents');
                //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
                $('#calendar table, #mini-calendar table').addClass('calendar-table');
              });

              /**
               * Aside Filters
               */
              $('#aside-filters .main-cat').on('change', function () {
                if ($(this).prop('checked')) {
                  if ($(this).parent().hasClass('parent')) {
                    $(this).parent().find('ul li input').each(function () {
                      $(this).prop("checked", true);
                    });
                  }
                  else {
                    $(this).prop("checked", false);
                  }
                  $(this).parent().parent().addClass('checked');
                  if ($(this).attr('id') == 'bienen-ensembles') {
                    $('#filters #bienen-ensembles').prop('checked', true);
                  }
                  if ($(this).attr('id') == 'festivals-series') {
                    $('#filters #festivals-series').prop('checked', true);
                  }
                  if ($(this).attr('id') == 'recitals-visiting-artists') {
                    $('#filters #recitals-visiting-artists').prop('checked', true);
                  }
                  if ($(this).attr('id') == 'student-recitals') {
                    $('#filters #student-recitals').prop('checked', true);
                  }
                }
                else {
                  $(this).parent().find('ul li input').each(function () {
                    $(this).prop("checked", false);
                  });
                  $(this).parent().parent().removeClass('checked');
                  if ($(this).attr('id') == 'bienen-ensembles') {
                    $('#filters #bienen-ensembles').prop('checked', false);
                  }
                  if ($(this).attr('id') == 'festivals-series') {
                    $('#filters #festivals-series').prop('checked', false);
                  }
                  if ($(this).attr('id') == 'recitals-visiting-artists') {
                    $('#filters #recitals-visiting-artists').prop('checked', false);
                  }
                  if ($(this).attr('id') == 'student-recitals') {
                    $('#filters #student-recitals').prop('checked', false);
                  }
                }
                renderListView(day_was_clicked, dayClicked);
                setCalendarListHeight();
              });

              $('#aside-filters .sub-cat').on('change', function () {
                if ($(this).prop('checked')) {
                  $(this).prop("checked", true);
                }
                else {
                  $(this).prop("checked", false);
                }
                renderListView(day_was_clicked, dayClicked);
              });

              $('#aside-filters ul li.parent label .ico').on('click', function () {
                if ($(this).parent().parent().hasClass('open')) {
                  $(this).parent().parent().removeClass('open');
                  $(this).parent().next().slideUp(400);
                }
                else {
                  $(this).parent().parent().addClass('open');
                  $(this).parent().next().slideDown(400);
                  var cnt_height = $('.list-view').height();
                  var filter_height = $('#aside-filters').height();
                  cnt_height = cnt_height + filter_height;
                  $('.list-view').css('height', cnt_height);
                }
              });

              // Set height on resize
              $(window).on('resize', function () {
                if ($(window).width() > 1180) {
                  setCalendarListHeight();
                }
              });

              if ($(window).width() < 719) {
                var windowWidth = $(window).width();
                $('.fc-listDay-button').trigger('click');
              } else {

              }

              //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
              $('#calendar table, #calendar .fc-content-skeleton table, #mini-calendar table, #mini-calendar .fc-content-skeleton table').addClass('calendar-table');
            });
        },
        finalize: function () {
          $(".searchblox form#search-events").submit(function (e) {
            // Encode filter field on submit
            var filterField = $(this).find("input[name='filter']");
            filterField.val(decodeURIComponent(filterField.val()));
            if (filterField.val() != undefined && filterField.val().startsWith('http') && !filterField.val().startsWith('url')) {
              // If filter doesn't have url: prefix, add it with quotation marks
              filterField.val('url:"' + filterField.val() + '*"');
            }
            filterField.val(encodeURIComponent(filterField.val()));
            return true;
          });
          // JavaScript to be fired on the home page, after the init JS
        }
      },


      // Faculty Calendar page
      'page_resources_faculty_calendar': {
          init: function () {

              var date = new Date();
              var d = date.getDate();
              var m = date.getMonth();
              var y = date.getFullYear();
              var day_was_clicked = false;
              var dayClicked;

              $.getJSON('/faculty-events?_format=json', function (data) {
              }).success(function (data) {
                  // Set Calendar List Height
                  function setCalendarListHeight() {
                      if ($('#events-calendar').hasClass('list-view')) {
                          var aside_height = $('aside').height() + 250;
                          var list_height = $('.list-events').height() + 350;
                          if (list_height > aside_height) {
                              $('.faculty-list-view').css('height', list_height);
                          }
                          else {
                              $('.faculty-list-view').css('height', aside_height);
                          }
                      }
                  }

                  var facultyEvents = [];


                  //console.log(data);

                  //Grab drupal data
                  for (var i = 0; i < data.length; i++) {
                      //Check if this is an All Day event
                      var endDate = new Date(data[i].end);
                      var daysOfYear = [];
                      for (var d = new Date(2012, 0, 1); d <= endDate; d.setDate(d.getDate() + 1)) {
                          daysOfYear.push(new Date(d));
                      }

                      facultyEvents.push({
                          title: data[i].title,
                          start: data[i].start,
                          end: data[i].end,
                          category: data[i].category.toString().replace(/&/g, "").replace(/\s+/g, '-').toLowerCase().replace(/,/g, " "),
                          location: data[i].location,
                          pdf: data[i].pdf,
                          allDay: data[i].allDay
                      });
                  }

                  // Render List View
                  function renderListView(day_was_clicked, dayClicked, month_view_date) {

                      var event_contents = '<div class="events-wrapper">';

                      // Check Top Filters
                      var top_vals = [];
                      $('#filters input:checked').each(function () {
                          top_vals.push($(this).val());
                      });

                      // Todays Date
                      var ntoday = new Date().getTime();

                      // Events
                      for (var key in facultyEvents) {


                          var eventStart = moment(facultyEvents[key].start).valueOf();
                          var eventEnd = moment(facultyEvents[key].end).valueOf();

                          // check if it is current event
                          if (eventStart > ntoday && eventEnd > ntoday) {

                              // check main category
                              if (top_vals.indexOf(facultyEvents[key].category) !== -1) {

                                  // Is a day active
                                  if (day_was_clicked == true) {
                                      var eventStartDate = moment(facultyEvents[key].start).format("MMMM DD, h:mmA");
                                      var eventDataDate = moment(facultyEvents[key].start);
                                      var checkEvent = moment(eventDataDate).format("YYYY-MM-DD");
                                      var monthDate = moment(month_view_date).format("YYYY-MM-DD");
                                      eventDataDate = eventDataDate.add(1, 'day').format('YYYY-MM-DD');
                                      var eventEndDate = moment(facultyEvents[key].end).format("MMMM DD, h:mmA");
                                      var eventTitle = facultyEvents[key].title;
                                      var eventCategory = facultyEvents[key].category;
                                      var eventLocation = facultyEvents[key].location;
                                      var eventPdf = facultyEvents[key].pdf;
                                      var eventAllDay = facultyEvents[key].allDay;
                                      var eventDayofWeek = moment(facultyEvents[key].start).format("dddd");
                                      var eventMonth = moment(facultyEvents[key].start).format("MMMM");
                                      var eventDayNumber = moment(facultyEvents[key].start).format("D");
                                      var eventTime = moment(facultyEvents[key].start).format("h:mmA");
                                      if (eventCategory == 'university') {
                                          var eventColor = 'violet';
                                      }
                                      if (eventCategory == 'deadlines') {
                                          var eventColor = 'blue';
                                      }
                                      if (eventCategory == 'meetings-events') {
                                          var eventColor = 'yellow';
                                      }
                                      if (eventCategory == 'bienen-events') {
                                          var eventColor = 'green';
                                      }
                                      if (dayClicked === eventDataDate) {
                                          event_contents += '<div class="faculty-event ' + eventCategory + '" data-date="' + eventDataDate + '" data-category="all ' + eventCategory + '">' +
                                              '<div class="row middle-xs">' +
                                              '<div class="col-xs-2">' +
                                              '<p class="day">' + eventDayofWeek + '</p>' +
                                              '<p class="month">' + eventMonth + '</p>' +
                                              '<p class="date">' + eventDayNumber + '</p>' +
                          '</div>' +
                                              '<div class="col-xs-8">' +
                                              '<div class="cnt">' +
                                              '<p class="title">' + eventTitle + '</p>';

                                          if (eventAllDay != 'ALL DAY') {
                                              event_contents += '<p class="time">' + eventTime + '</p>';
                                          }

                                          if (eventLocation) {
                                              event_contents += '<p class="location">' + eventLocation + '</p>';
                                          }

                                          event_contents += '</div>' +
                                              '</div>';

                                          if (eventPdf.length > 0) {
                                              event_contents += '<div class="col-xs-2">' +
                                                  '<a href="' + eventPdf + '" class="body-link"><span>Link to Agenda</span></a>' +
                                                  '</div>';
                                          }

                                          event_contents += '</div>' +
                                              '</div>';
                                      }
                                  }
                                  else {
                                      var eventStartDate = moment(facultyEvents[key].start).format("MMMM DD, h:mmA");
                                      var eventDataDate = moment(facultyEvents[key].start);
                                      var checkEvent = moment(eventDataDate).format("YYYY-MM-DD");
                                      var monthDate = moment(month_view_date).format("YYYY-MM-DD");
                                      eventDataDate = eventDataDate.add(1, 'day');
                                      var eventEndDate = moment(facultyEvents[key].end).format("MMMM DD, h:mmA");
                                      var eventTitle = facultyEvents[key].title;
                                      var eventCategory = facultyEvents[key].category;
                                      var eventLocation = facultyEvents[key].location;
                                      var eventPdf = facultyEvents[key].pdf;
                                      var eventAllDay = facultyEvents[key].allDay;
                                      var eventDayofWeek = moment(facultyEvents[key].start).format("dddd");
                                      var eventMonth = moment(facultyEvents[key].start).format("MMMM");
                                      var eventDayNumber = moment(facultyEvents[key].start).format("D");
                                      var eventTime = moment(facultyEvents[key].start).format("h:mmA");
                                      if (eventCategory == 'university') {
                                          var eventColor = 'violet';
                                      }
                                      if (eventCategory == 'deadlines') {
                                          var eventColor = 'blue';
                                      }
                                      if (eventCategory == 'meetings-events') {
                                          var eventColor = 'yellow';
                                      }
                                      if (eventCategory == 'bienen-events') {
                                          var eventColor = 'green';
                                      }
                                      if (month_view_date) {
                                          if (checkEvent > monthDate) {
                                              event_contents += '<div class="faculty-event ' + eventCategory + '" data-date="' + eventDataDate + '" data-category="all ' + eventCategory + '">' +
                                                  '<div class="row middle-xs">' +
                                                  '<div class="col-xs-2">' +
                                                  '<p class="day">' + eventDayofWeek + '</p>' +
                                                  '<p class="month">' + eventMonth + '</p>' +
                                                  '<p class="date">' + eventDayNumber + '</p>' +
                          '</div>' +
                                                  '<div class="col-xs-8">' +
                                                  '<div class="cnt">' +
                                                  '<p class="title">' + eventTitle + '</p>';

                                              if (eventAllDay != 'ALL DAY') {
                                                  event_contents += '<p class="time">' + eventTime + '</p>';
                                              }

                                              if (eventLocation) {
                                                  event_contents += '<p class="location">' + eventLocation + '</p>';
                                              }

                                              event_contents += '</div>' +
                                                  '</div>';

                                              if (eventPdf.length > 0) {
                                                  event_contents += '<div class="col-xs-2">' +
                                                      '<a href="' + eventPdf + '" class="body-link"><span>Link to Agenda</span></a>' +
                                                      '</div>';
                                              }

                                              event_contents += '</div>' +
                                                  '</div>';
                                          }
                                      }
                                      else {
                                          event_contents += '<div class="faculty-event ' + eventCategory + '" data-date="' + eventDataDate + '" data-category="all ' + eventCategory + '">' +
                                              '<div class="row middle-xs">' +
                                              '<div class="col-xs-2">' +
                                              '<p class="day">' + eventDayofWeek + '</p>' +
                                              '<p class="month">' + eventMonth + '</p>' +
                                              '<p class="date">' + eventDayNumber + '</p>' +
                          '</div>' +
                                              '<div class="col-xs-8">' +
                                              '<div class="cnt">' +
                                              '<p class="title">' + eventTitle + '</p>' +
                                              '<p class="time">' + eventTime + '</p>';

                                          if (eventLocation) {
                                              event_contents += '<p class="location">' + eventLocation + '</p>';
                                          }

                                          event_contents += '</div>' +
                                              '</div>';

                                          if (eventPdf.length > 0) {
                                              event_contents += '<div class="col-xs-2">' +
                                                  '<a href="' + eventPdf + '" class="body-link"><span>Link to Agenda</span></a>' +
                                                  '</div>';
                                          }

                                          event_contents += '</div>' +
                                              '</div>';
                                      }
                                  }
                              }
                          }
                      }
                      event_contents += "</div>";
                      $('#faculty-calendar .fc-view-container').hide();
                      $(".list-events").html(event_contents);

                      // No Events
                      if ($('#faculty-resources > .col-xs-8').hasClass('faculty-list-view')) {
                          if ($('.list-events .events-wrapper .faculty-event').length < 1) {
                              $('.no-events').show();
                          }
                          else {
                              $('.no-events').hide();
                          }
                      }

                      // Sidebar
                      if ($('aside').length > 0) {
                          $('aside > *').each(function (e) {
                              var aside = $(this);
                              var waypoint_aside = new Waypoint({
                                  element: aside[0],
                                  handler: function (direction) {
                                      if (direction === 'down') {
                                          aside.addClass('on');
                                      }
                                  },
                                  offset: '100%'
                              });
                          });
                      }

                      // Article
                      if ($('.events-wrapper').length > 0) {
                          $('.events-wrapper > *').not('form').each(function (e) {
                              var article = $(this);
                              var waypoint_article = new Waypoint({
                                  element: article[0],
                                  handler: function (direction) {
                                      if (direction === 'down') {
                                          article.addClass('on');
                                      }
                                  },
                                  offset: '100%'
                              });
                          });
                      }
                  }


                  // Mini Calendar
                  var $mini_calendar = $("#faculty-mini-calendar");
                  $mini_calendar.fullCalendar({
                      header: {
                          left: 'prev',
                          center: 'title',
                          right: 'next'
                      },
                      weekends: true,
                      allDaySlot: false,
                      droppable: true,
                      events: facultyEvents,
                      titleFormat: "MMMM YYYY",
                      columnFormat: 'ddd',
                      timeFormat: 'h:mmt',
                      eventRender: function (event, e, view) {
                          $(e).addClass(event.category);
                          var eventStart = moment(event.start);
                          var eventEnd = event._end === null ? eventStart : moment(event.end);
                          var diffInDays = eventEnd.diff(eventStart, 'days');
                          if (!$("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-past')) {
                              if (!$("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                                  $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                                  for (var i = 1; i < diffInDays; i++) {
                                      eventStart.add(1, 'day');
                                      $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-events');
                                  }
                                  var tooltipHtml = document.createElement('div');
                                  tooltipHtml.setAttribute("class", "tooltip");
                                  var tooltip_contents = '<p class="date ' + event.category + '">' + moment(event.start).format('h:mmA') + '</p><p class="title">' + event.title + '</p>';
                                  tooltipHtml.innerHTML = tooltip_contents;
                                  $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").append(tooltipHtml);
                              }
                          }
                          if ($("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").hasClass('fc-other-month')) {
                              $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                              for (var i = 1; i < diffInDays; i++) {
                                  eventStart.add(1, 'day');
                                  $("td[data-date='" + eventStart.format('YYYY-MM-DD') + "']").addClass('has-future-events');
                              }
                          }
                      },
                      dayClick: function (date, event, view) {
                          date.add(1, 'day');
                          if ($(this).hasClass('has-events')) {
                              if ($(event.target).hasClass('active')) {
                                  $(event.target).removeClass("active");
                                  day_was_clicked = false;
                                  dayClicked = '';
                              }
                              else {
                                  dayClicked = moment(date).format('YYYY-MM-DD');
                                  day_was_clicked = true;
                                  $('#faculty-mini-calendar .fc-row td span').removeClass('active');
                                  $(event.target).addClass("active");
                              }
                              renderListView(day_was_clicked, dayClicked);
                              setCalendarListHeight();
                          }
                      },
                      eventAfterAllRender: function (event, element) {
                          $('.has-events').each(function () {
                              var day = $(this).find('.fc-day-number').html();
                              if (!$(this).children().hasClass('tooltip-wrapper')) {
                                  $(this).html(function (i, html) {
                                      return '<span class="fc-day-number">' + day + '</span><div class="tooltip-wrapper">' + html + '</div>';
                                  });
                              }
                          });
                          for (var i = 0; i < $(".fc-day-grid .fc-week").length; i++) {
                              $(".fc-week:eq(" + i + ")").css("z-index", ($(".fc-day-grid .fc-week").length - i));
                          }

                          // Keep both calendars sync'd
                          var month_view_date = $('#faculty-mini-calendar').fullCalendar('getDate');
                          $("#faculty-calendar").fullCalendar('gotoDate', month_view_date);
                          renderListView(day_was_clicked, dayClicked, month_view_date);
                      }
                  });

                  // Event Calendar
                  var $calendar = $("#faculty-calendar");
                  $calendar.fullCalendar({
                      header: {
                          left: 'month,listDay',
                          center: 'prev,next, title',
                          right: ''
                      },
                      weekends: true,
                      allDaySlot: false,
                      droppable: true,
                      events: facultyEvents,
                      titleFormat: "MMMM 'YY",
                      columnFormat: 'dddd',
                      timeFormat: 'h:mmt',
                      timezone: false,
                      eventAfterAllRender: function (view) {
                          // Set View
                          var currentView = $('#faculty-calendar').fullCalendar('getView').name;
                          if (currentView == 'listDay') {
                              $('#faculty-calendar').parent().parent().removeClass('faculty-month-view');
                              $('#faculty-calendar').parent().parent().addClass('faculty-list-view');
                              $('#faculty-mini-calendar').css({
                                  'opacity': '1',
                                  'height': 'auto'
                              });
                              $('#faculty-calendar .fc-view-container').prop('style', null); //not
                                                                                             // working
                              $('#faculty-calendar .fc-view-container').css({
                                  'display': 'block',
                                  'opacity': '0',
                                  'height': '0px'
                              });

                              // Keep both calendars sync'd
                              var month_view_date = $('#faculty-calendar').fullCalendar('getDate');
                              $("#faculty-mini-calendar").fullCalendar('gotoDate', month_view_date);
                          }
                          if (currentView == 'month') {
                              $('#faculty-calendar').parent().parent().addClass('faculty-month-view');
                              $('#faculty-calendar').parent().parent().removeClass('faculty-list-view');
                              $('#faculty-mini-calendar').css({
                                  'opacity': '0',
                                  'height': '0px'
                              });
                              $('#faculty-calendar .fc-view-container').prop('style', null); //not
                                                                                             // working
                              $('#faculty-calendar .fc-view-container').css({
                                  'display': 'block',
                                  'opacity': '1',
                                  'height': 'auto'
                              });
                              $(".list-events").html('');
                              $('#faculty-mini-calendar .fc-content-skeleton .has-events span').removeClass('active');
                              day_was_clicked = false;
                              dayClicked = '';
                          }

                          // Create Header
                          var header = $calendar.find(".fc-header-toolbar");

                          // Insert Header Filerts
                          if ($('#filters').length < 1) {
                              var filtersHtml = document.createElement('ul');
                              filtersHtml.setAttribute("id", "filters");
                              filtersHtml.setAttribute("class", "checkboxes");
                              var filter_contents = '<li class="filter-title">Upcoming</li>' +
                                  '<li><input type="checkbox" checked id="university" value="university" /><label class="university">University</label></li>' +
                                  '<li><input type="checkbox" checked id="deadlines" value="deadlines" /><label class="deadlines">Deadlines</label></li>' +
                                  '<li><input type="checkbox" checked id="meetings-events" value="meetings-events" /><label class="meetings-events">Meetings &amp; Events</label></li>' +
                                  '<li><input type="checkbox" checked id="bienen-events" value="bienen-events" /><label class="bienen-events">Bienen Events</label></li>';
                              filtersHtml.innerHTML = filter_contents;
                              $calendar.find(".fc-center").append(filtersHtml);
                          }

                          // Insert Button Classes
                          $('.fc-month-button').addClass('btn');
                          $('.fc-listDay-button').addClass('btn');
                          $('.fc-month-button').text('Calendar View');
                          $('.fc-listDay-button').text('List View');

                          // Trigger Current View
                          header.find('.fc-left').find('.fc-button').off('mouseup').on('mouseup', function () {
                              if (!$(this).hasClass('fc-listDay-button')) {
                                  $calendar.data("view", '');
                              }
                          });
                          if ($('#faculty-calendar').fullCalendar('getView').name != 'listDay') {
                              header.find(".fc-listDay-button").removeClass('fc-state-active active');
                              $("#listDay").remove();
                          }
                          else {
                              renderListView(day_was_clicked, dayClicked, month_view_date);
                          }
                          setCalendarListHeight();

                          if ($(window).width() < 681) {
                              var windowWidth = $(window).width();
                              $('.fc-event').each(function () {
                                  if ($(this).offset().left < windowWidth / 2) {
                                      $(this).addClass('left');
                                  }
                                  else {
                                      $(this).addClass('right');
                                  }
                              });
                          }
                      },
                      eventRender: function (event, e) {
                          $(e).addClass(event.category);
                          var ntoday = new Date().getTime();
                          var eventStart = moment(event.start).valueOf();
                          var eventEnd = moment(event.end).valueOf();

                          if (!event.end) {
                              if (eventStart < ntoday) {
                                  e.addClass("past-event");
                                  e.children().addClass("past-event");
                              }
                          }
                          else {
                              if (eventEnd < ntoday) {
                                  e.addClass("past-event");
                                  e.children().addClass("past-event");
                              }
                          }
                          return filter(event);
                      },
                      dayClick: function (date, jsEvent, view) {

                      },
                      eventClick: function (calEvent, jsEvent, view) {

                      }
                  });

                  // Render Calendar onload
                  $(window).on('load', function () {
                      $('#faculty-calendar').fullCalendar('rerenderEvents');
                      //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
                      $('#faculty-calendar .fc-view-container table').addClass('calendar-table');
                  });

                  // Return Filters
                  function filter(event) {
                      var vals = [];
                      $('#filters input:checked').each(function () {
                          vals.push($(this).val());
                      });
                      return vals.indexOf(event.category) !== -1;
                  }

              });

              // Top Filters
              $('#filters').on('change', function () {
                  $('#faculty-calendar').fullCalendar('rerenderEvents');
                  //Adding classes for styling; tables in WYSIWYG editor conflicts with the tables here - SM
                  $('#faculty-calendar table').addClass('calendar-table');
              });

              // Set height on resize
              $(window).on('resize', function () {
                  if ($(window).width() > 1180) {
                      setCalendarListHeight();
                  }
              });

          },
          finalize: function () {
              // JavaScript to be fired on the home page, after the init JS
          }
      },

    };

    // The routing fires all common scripts, followed by the page specific
    // scripts. Add additional events for more control over timing e.g. a
    // finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = funcname === undefined ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

    $(document).ready(function () {
        
        // Rest of your document ready code
    });
})(window.jQuery, window.Clique); // Fully reference jQuery after this point.
